(function(){
  "use strict";

  /* Savings anchor on the single-kit price x the number of kits, same as the live PDP's
     compare-at. $49.97 is a price a customer can actually buy (the 1-pack is live), so it is
     a real anchor, not an invented one. The one-time price of the same box is shown too, on
     the "Just try it" button, so all three numbers are on screen at once. */
  var LIST = 49.97;

  /* Quiz ladder: 2 / 4 / 6 kits. The 6 matches the live store exactly ($125.97 subscribe,
     $199.97 one-time). The 2 and 4 are new subscription boxes built for this funnel — the
     store's 1/3/6 grid anchors a price shopper on a single kit, which is what this page exists
     to avoid. One-time anchors: the 2-kit $84.97 already exists as a standalone SKU.
     Price is set by pack size only — frequency never changes it, same as the live store. */
  var TIERS = [
    { kits:2, once:89.97,  cad:[{d:28,p:69.97},{d:56,p:80.97},{d:84,p:88.97}] },
    { kits:4, once:149.97, cad:[{d:28,p:104.97},{d:56,p:121.97},{d:84,p:132.97}] },
    { kits:6, once:199.97, cad:[{d:28,p:125.97},{d:56,p:145.97},{d:84,p:159.97}] }
  ];

  function cadLab(c, n){ return c.m ? (c.m === 1 ? (n ? '1 month' : 'month') : c.m + ' months') : (c.d / 7) + ' weeks'; }
  var STEPS = [
    { key:"people", kicker:"Let's build your box", layout:"row3",
      title:"How many at your pizza night?",
      sub:"We size your box from this.",
      opts:[
        {k:"2", t:"Just the two of us", s:"Or just me", pies:2},
        {k:"4", t:"Three or four", s:"A normal family night", pies:3},
        {k:"6", t:"Five or more", s:"A full table", pies:5}
      ]},
    { key:"avoid", kicker:"Quick check", branch:true,
      title:"Anyone avoiding anything?",
      sub:"Quick check.",
      opts:[
        {k:"none",    t:"Nope. We eat it all.", s:"On to the fun part"},
        {k:"gluten",  t:"Gluten or wheat", s:"One more question on that"},
        {k:"allergy", t:"A food allergy", s:"Nuts, milk, eggs", route:"info"},
        {k:"rule",    t:"A food rule", s:"Vegan, kosher, halal, or I read every label"}
      ]},
    { key:"rule", kicker:"Which one?", branch:true,
      when: a => a.avoid && a.avoid.k === "rule",
      title:"Which one fits you?",
      sub:"Straight answer coming.",
      opts:[
        {k:"vegan",  t:"Vegan", s:"No animal products", route:"info"},
        {k:"kosher", t:"Kosher", s:"", route:"info"},
        {k:"halal",  t:"Halal", s:"", route:"info"},
        {k:"clean",  t:"I read every label", s:"No junk, no fillers", route:"info"}
      ]},
    { key:"why", kicker:"One more on that", branch:true,
      when: a => a.avoid && a.avoid.k === "gluten",
      title:"What's behind it?",
      sub:"One quick check.",
      opts:[
        {k:"celiac",  t:"Celiac disease", s:"Diagnosed", route:"stop"},
        {k:"allergy", t:"A diagnosed wheat allergy",
         s:"Tested — hives, swelling, trouble breathing", route:"stop"},
        {k:"neither", t:"Neither of those",
         s:"By choice, on general advice, or wheat just doesn't agree with me", route:"learn"}
      ]},
    { key:"freq", kicker:"How often", card:"proof",
      title:"How often does pizza night actually happen?",
      sub:"Be honest.",
      opts:[
        {k:"m", t:"Once or twice a month", s:"A treat, not a routine", per:2},
        {k:"w", t:"Most weeks", s:"It's a standing thing", per:4.33},
        {k:"d", t:"A couple of times a week", s:"You're deep in it", per:8.67}
      ]},
    { key:"oven", kicker:"Your kitchen", layout:"grid2", card:"oven",
      title:"Where are you cooking it?",
      sub:"It works in all of them.",
      opts:[
        {k:"oven", t:"A pizza oven", s:"Gozney, Ooni, Bertello",
         fit:"Built for high heat. You're starting from the easiest place there is."},
        {k:"home", t:"My home oven", s:"Gas or electric, regular kitchen oven",
         fit:"A home oven and a cookie sheet is enough. No stone. No steel. The steps cover it."},
        {k:"grill", t:"The grill", s:"Gas, charcoal, or wood",
         fit:"A grill runs hotter than most ovens. That helps. The steps cover gas and charcoal."},
        {k:"kamado", t:"A kamado", s:"Green Egg, Kamado Joe, Vision",
         fit:"High, even heat. Exactly what this dough wants."}
      ]},
    { key:"style", kicker:"Your pizza", layout:"row3", card:"kit",
      title:"What kind of pizza are you making?",
      sub:"Pick the one you picture.",
      opts:[
        {k:"hand", t:"Hand tossed", s:"That puffy edge. Neapolitan style."},
        {k:"thin", t:"Thin", s:"Roman or Chicago style."},
        {k:"pan",  t:"Thick / pan", s:"Sicilian or Detroit style."}
      ]},

    { key:"exp", kicker:"Almost done", card:"help",
      title:"Have you made pizza dough before?",
      sub:"No wrong answers.",
      opts:[
        {k:"flop",  t:"Tried, but it failed", s:"Flat, tough, or it wouldn't stretch"},
        {k:"never", t:"Never made dough", s:"This would be my first time"},
        {k:"meh",   t:"Made it, but never quite right", s:"Good, not pizzeria good"}
      ]},
    { key:"want", kicker:"One more", card:"quality",
      title:"What matters most on pizza night?",
      sub:"Pick one.",
      opts:[
        {k:"taste", t:"Taste as good as a pizzeria", s:"That is the whole point"},
        {k:"price", t:"Getting a good price", s:"Feeding the table for less"},
        {k:"time",  t:"Saving time", s:"Easy nights, less fuss"},
        {k:"try",   t:"Just trying something new", s:"Seeing what it is like"}
      ]},
  ];

  /* Pizzas per kit by style and size — Michael's figures, Oct 2026. Pan sizes are the pans
     people actually own, not diameters. These drive the box recommendation, the per-pizza
     price and the macros strip, so they are the most load-bearing numbers on the page. */
  var PER_KIT = 6;   /* the standard, and it never changes with style or size. The size grid is
                        awareness only — not an input, and nothing downstream recalculates from it. */
  var STYLE_NAME = { hand:"Hand tossed", thin:"Thin", pan:"Thick / pan" };
  var SIZES = {
    hand: [
      {k:"s", t:'8–10 inch',  s:"8 per kit",  label:'8–10"',  yield:8,  slices:6},
      {k:"m", t:'10–12 inch', s:"6 per kit",  label:'10–12"', yield:6,  slices:8},
      {k:"l", t:'14–16 inch', s:"3 per kit",  label:'14–16"', yield:3,  slices:8}
    ],
    thin: [
      {k:"s", t:'8–10 inch',  s:"10 per kit", label:'8–10"',  yield:10, slices:6},
      {k:"m", t:'10–12 inch', s:"8 per kit",  label:'10–12"', yield:8,  slices:8},
      {k:"l", t:'14–16 inch', s:"6 per kit",  label:'14–16"', yield:6,  slices:8}
    ],
    pan: [
      {k:"s", t:'8×8 pan',     s:"4 per kit", label:'8×8 pan',     yield:4, slices:4},
      {k:"m", t:'8×10 pan',    s:"3 per kit", label:'8×10 pan',    yield:3, slices:6},
      {k:"l", t:'13×18 sheet', s:"2 per kit", label:'13×18 sheet', yield:2, slices:8}
    ]
  };

  var answers = {};
  var step = 0;
  var lead = null;          /* captured email, or "skipped" */

  var card  = document.getElementById("card");
  var prog  = document.getElementById("prog");

  var sayEl   = document.getElementById("say");
  var below   = document.getElementById("below");
  var sticky  = document.getElementById("sticky");

  /* ---- reviews. Judge.me = verbatim from the product review widget (Shopify metafield).
         Homepage = quoted on prepapizza.com; excerpts marked … — confirm wording in the Judge.me export.
         FB = Facebook ad comment, verbatim. ---- */
  var R = {
    michele:{n:"Michele Kellenberger", src:"Verified buyer", q:"I've tried multiple crust and none have worked out, I was going to sell my pizza oven because I was so frustrated with it. If you haven't tried it go for it you won't regret it!!!"},
    eric:   {n:"Eric Lasp", src:"Verified buyer", q:"Prepa makes pizza night so easy, it feels like a cheat code!"},
    mike:   {n:"Mike Anderson", src:"Verified buyer", q:"I have used this dough for about a year now and just reordered…"},
    cheryl: {n:"Cheryl Fogg", src:"Verified buyer", q:"It came out great! It may have looked like Indiana but it tasted so good, and crispy too! Can’t wait to make another"},
    wb:     {n:"W.B.", src:"Verified buyer", q:"Love it. Its so easy. Taste is very best & i tried quite a few & also home recipes"},
    kevin:  {n:"Kevin Jermyn", src:"Verified buyer", q:"The crust was restaurant quality!"},
    ian:    {n:"Ian Riding", src:"Verified buyer", q:"This company is absolutely fantastic at follow up and actually cares about their customers results."},
    pam:    {n:"Pam Krukowski", src:"Verified buyer", q:"If you want great tasting pizza that is easy and fun to make, buy this crust mix now!!"},
    gordon: {n:"J Gordon", src:"Verified buyer", q:"This dough and sauce makes incredible pizza… I'm keeping stocked so I can make it every week."},
    todd:   {n:"Todd R", src:"Verified buyer", q:"Ingredients were just what we're looking for… they tasted fantastic."},
    matthew:{n:"Matthew T. DuBoise", src:"Verified buyer", q:"I like to consider myself a pizza snob… I was blown away at how good the pizza I pulled out of my oven was!"},
    danny:  {n:"Danny Jimenez", src:"Verified buyer", q:"I'm a professional chef by trade… This dough is great. Flavorful, and easy to make."},
    andrew: {n:"Andrew", src:"Facebook comment", q:"Kudos to Prepa Pizza for NOT using enriched flour in their dough mix."}
  };
  /* which voice sits under which screen — each one answers the doubt that screen raises */
  var SAY = { people:"pam", avoid:"andrew", rule:"todd", why:"andrew", learn:"andrew", info:"todd",
              freq:"matthew", size:"kevin", exp:"ian", help:"eric", want:"danny", quality:"todd", profile:"gordon", oven:"michele", gate:"ian", result:"wb" };

  function stars(){ return '<span class="stars" aria-label="5 stars">★★★★★</span>'; }
  function say(key){
    var r = key && R[SAY[key]];
    if (!r) { sayEl.innerHTML = ""; return; }
    sayEl.innerHTML = '<figure class="say" style="margin:14px 0 0">' +
      '<div class="av" aria-hidden="true">' + r.n.charAt(0) + '</div>' +
      '<div><p>“' + r.q + '”</p><footer>' + stars() + '<b>' + r.n + '</b>' +
      '<span class="vf">' + r.src + '</span></footer></div></figure>';
  }
  /* ---- Back follows the path this person actually took. PATH holds the question steps they saw, in order.
         On a question, Back goes to the question before it. On an info/help page, Back goes to the question that led there. ---- */
  var PATH = [], onQuestion = false;
  function goBack(){
    if (onQuestion) PATH.pop();
    var prev = PATH.pop();
    step = (prev === undefined) ? 0 : prev;
    renderStep();
    window.scrollTo({ top:0, behavior:"smooth" });
  }
  function hideBelow(){ onQuestion = false; below.hidden = true; below.innerHTML = ""; sticky.hidden = true;
                        document.body.classList.remove("has-sticky"); }

  /* ---- option art: plain shapes, brand colours ---- */
  function pizza(r, rim){
    rim = rim || 3.2;
    var c = 32, h = '<svg width="64" height="64" viewBox="0 0 64 64" aria-hidden="true">' +
      '<circle cx="32" cy="32" r="31" fill="none" stroke="#ebe3cf" stroke-dasharray="2 3"/>' +
      '<circle cx="'+c+'" cy="'+c+'" r="'+r+'" fill="#e3a857"/>' +
      '<circle cx="'+c+'" cy="'+c+'" r="'+(r-rim)+'" fill="#d0473e"/>';
    var spots = [[-.34,-.26,.17],[.31,-.1,.19],[-.09,.33,.17],[.26,.35,.13],[-.4,.18,.11],[.04,-.44,.12]];
    spots.forEach(function(p){ h += '<circle cx="'+(c+p[0]*r)+'" cy="'+(c+p[1]*r)+'" r="'+(p[2]*r)+'" fill="#f7e3b0"/>'; });
    [[.1,-.2],[-.3,.05],[.35,.15]].forEach(function(p){ h += '<ellipse cx="'+(c+p[0]*r)+'" cy="'+(c+p[1]*r)+'" rx="'+(.09*r)+'" ry="'+(.05*r)+'" fill="#0f855b"/>'; });
    return h + '</svg>';
  }
  function people(n){
    /* simple person glyphs: 2 in a row, 4 in a row, 6 in two rows of 3 (back row smaller, lighter) */
    function man(x, y, sc, fill){
      return '<g transform="translate('+x+' '+y+') scale('+sc+')">' +
        '<circle cx="0" cy="-9" r="5" fill="'+fill+'"/>' +
        '<path d="M-8.5 8 C-8.5 -1 -5 -3 0 -3 C5 -3 8.5 -1 8.5 8 Z" fill="'+fill+'"/></g>';
    }
    var h = '<svg width="64" height="52" viewBox="0 0 64 52" aria-hidden="true">';
    if (n === 2) h += man(23,30,1.25,"#253230") + man(41,30,1.25,"#d0473e");
    else if (n === 4) h += man(10,31,.95,"#253230") + man(24.5,31,.95,"#d0473e") + man(39.5,31,.95,"#253230") + man(54,31,.95,"#0f855b");
    else h += man(16,22,.8,"#9aa6a3") + man(32,22,.8,"#9aa6a3") + man(48,22,.8,"#9aa6a3") +
              man(12,38,.95,"#253230") + man(32,38,.95,"#d0473e") + man(52,38,.95,"#0f855b");
    return h + '</svg>';
  }
  function cal(n){
    var h = '<svg width="64" height="52" viewBox="0 0 64 52" aria-hidden="true">' +
            '<rect x="3" y="3" width="58" height="46" rx="6" fill="#fff" stroke="#253230" stroke-width="1.4"/>' +
            '<rect x="3" y="3" width="58" height="9" rx="4" fill="#253230"/>';
    var on = n === 2 ? [9,23] : n === 4 ? [4,11,18,25] : [1,4,8,11,15,18,22,25,27];
    for (var i = 0; i < 28; i++){
      var x = 8 + (i%7)*7.6, y = 18 + Math.floor(i/7)*7.6;
      h += '<circle cx="'+x.toFixed(1)+'" cy="'+y.toFixed(1)+'" r="2.6" fill="'+(on.indexOf(i)>-1?'#d0473e':'#ebe3cf')+'"/>';
    }
    return h + '</svg>';
  }
  var OVEN = {
    oven:'<svg width="64" height="52" viewBox="0 0 64 52" aria-hidden="true"><path d="M8 44 V30 a24 22 0 0 1 48 0 V44 Z" fill="#fff" stroke="#253230" stroke-width="1.6"/><path d="M22 44 V36 a10 9 0 0 1 20 0 V44" fill="#253230"/><path d="M27 42 q5-8 10 0" fill="#d0473e"/><rect x="4" y="44" width="56" height="4" rx="2" fill="#253230"/></svg>',
    home:'<svg width="64" height="52" viewBox="0 0 64 52" aria-hidden="true"><rect x="10" y="4" width="44" height="44" rx="4" fill="#fff" stroke="#253230" stroke-width="1.6"/><circle cx="18" cy="11" r="2" fill="#253230"/><circle cx="25" cy="11" r="2" fill="#253230"/><rect x="16" y="18" width="32" height="24" rx="3" fill="#253230"/><rect x="20" y="31" width="24" height="3" rx="1.5" fill="#d0473e"/></svg>',
    grill:'<svg width="64" height="52" viewBox="0 0 64 52" aria-hidden="true"><path d="M10 20 h44 a22 16 0 0 1 -44 0 Z" fill="#253230"/><path d="M12 18 a20 13 0 0 1 40 0 Z" fill="#fff" stroke="#253230" stroke-width="1.6"/><path d="M20 36 L14 48 M44 36 L50 48" stroke="#253230" stroke-width="2"/><path d="M26 29 q3-5 0-8 M32 30 q3-5 0-8 M38 29 q3-5 0-8" stroke="#d0473e" stroke-width="1.6" fill="none"/></svg>',
    kamado:'<svg width="64" height="52" viewBox="0 0 64 52" aria-hidden="true"><ellipse cx="32" cy="26" rx="17" ry="20" fill="#0f855b"/><path d="M15 24 h34" stroke="#fff" stroke-width="1.6"/><rect x="29" y="3" width="6" height="4" rx="1.5" fill="#253230"/><path d="M8 26 h7 M49 26 h7" stroke="#253230" stroke-width="2"/><path d="M24 46 L20 50 M40 46 L44 50" stroke="#253230" stroke-width="2"/></svg>'
  };
  function pan(w, h){
    var sc = 44 / Math.max(w, h), pw = w * sc, ph = h * sc;
    var x = 32 - pw / 2, y = 26 - ph / 2;
    return '<svg width="64" height="52" viewBox="0 0 64 52" aria-hidden="true">' +
      '<rect x="' + (x-2).toFixed(1) + '" y="' + (y-2).toFixed(1) + '" width="' + (pw+4).toFixed(1) + '" height="' + (ph+4).toFixed(1) + '" rx="4" fill="#9aa6a3"/>' +
      '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + pw.toFixed(1) + '" height="' + ph.toFixed(1) + '" rx="3" fill="#e3a857"/>' +
      '<rect x="' + (x+3).toFixed(1) + '" y="' + (y+3).toFixed(1) + '" width="' + Math.max(0,pw-6).toFixed(1) + '" height="' + Math.max(0,ph-6).toFixed(1) + '" rx="2" fill="#d0473e"/>' +
      '</svg>';
  }
  var SIZE_ART = {
    hand: { s:pizza(21, 4.2), m:pizza(26, 4.6), l:pizza(31, 5) },
    thin: { s:pizza(21, 2),   m:pizza(26, 2.2), l:pizza(31, 2.4) },
    pan:  { s:pan(8, 8),      m:pan(8, 10),     l:pan(13, 18) }
  };
  var STYLE_ART = { hand:pizza(27, 5.4), thin:pizza(27, 2), pan:pan(8, 10) };
  var ART = {
    people:{ "2":people(2), "4":people(4), "6":people(6) },
    freq:  { m:cal(2), w:cal(4), d:cal(9) },
    style: STYLE_ART,
    size:  SIZE_ART.hand,
    oven:  OVEN
  };


  function money(n){ return "$" + n.toFixed(2); }
  function round1(n){ return Math.round(n * 10) / 10; }

  /* progress in three named chapters, not a row of identical dashes */
  var CH = [ {t:"Your table", keys:["people","avoid","rule","why"]},
             {t:"Your pizza nights", keys:["freq","oven","style"]},
             {t:"Your dough", keys:["exp","want"]} ];
  prog.innerHTML = CH.map(function(c, i){
    return '<div class="ch"><span class="ch-n">' + (i+1) + '</span><span class="ch-t">' + c.t + '</span><i><b></b></i></div>';
  }).join('');
  function drawProg(){
    var key = step < STEPS.length ? STEPS[step].key : null;
    var at = key ? CH.findIndex(function(c){ return c.keys.indexOf(key) > -1; }) : CH.length;
    Array.prototype.forEach.call(prog.children, function(el, i){
      var fill = 0;
      if (i < at) fill = 100;
      else if (i === at) {
        var ks = CH[i].keys.filter(function(k){ var st = STEPS.find(function(x){return x.key===k;}); return !st.when || st.when(answers); });
        fill = Math.round(100 * (Math.max(0, ks.indexOf(key)) + .5) / ks.length);
      }
      el.className = "ch" + (i < at ? " done" : i === at ? " on" : "");
      el.querySelector("b").style.width = fill + "%";
    });
  }

  function renderStep(){
    if (step === 0) PATH = [];
    if (PATH[PATH.length - 1] !== step) PATH.push(step);
    var s = STEPS[step];
    drawProg();
    hideBelow();

    var val = function(x){ return typeof x === "function" ? x(answers) : x; };
    var OPTS = val(s.opts);

    var html =
      '<div class="kicker">' + s.kicker + '</div>' +
      '<h1 class="qtitle">' + val(s.title) + '</h1>' +
      '<p class="qsub">' + val(s.sub) + '</p>' +
      '<div class="answers' + (s.layout ? ' ' + s.layout : '') + '">';

    if (s.type === "slider") { renderSlider(s, html); return; }
    var picked = s.multi ? (answers[s.key] || []) : null;

    OPTS.forEach(function(o, i){
      var on = s.multi && picked.indexOf(o.k) > -1;
      var art = ART[s.key] && ART[s.key][o.k];
      html += '<button type="button" class="ans' + (on ? " on" : "") + (art ? " has-m" : "") + (s.layout ? " tile" : "") + '" data-i="' + i + '"' +
                (s.multi ? ' aria-pressed="' + (on ? "true" : "false") + '"' : '') + '>' +
                (art ? '<span class="ans-m">' + art + '</span>'
                     : '<span class="ans-k" aria-hidden="true">' + (s.multi ? (on ? "✓" : "") : (i + 1)) + '</span>') +
                '<span><span class="ans-t">' + o.t + '</span>' +
                (o.s ? '<span class="ans-s">' + o.s + '</span>' : '') + '</span>' +
              '</button>';
    });
    html += '</div>';
    if (s.confirm) html += '<div class="tip" id="tip" hidden></div><button type="button" class="cta" id="confirm" disabled>Continue</button>';

    if (s.multi) {
      html += '<button type="button" class="cta" id="go">' +
                (picked.length ? "Continue" : "None of these — continue") + '</button>';
    }
    if (step > 0) html += '<button type="button" class="back" id="back">← Back</button>';

    card.innerHTML = html;
    onQuestion = true;
    say(s.key);

    function advance(){
      step++;
      while (step < STEPS.length && STEPS[step].when && !STEPS[step].when(answers)) step++;
      if (step < STEPS.length) renderStep();
      else if (!lead) renderBuild();
      else renderResult();
      window.scrollTo({ top:0, behavior:"smooth" });
    }

    Array.prototype.forEach.call(card.querySelectorAll(".ans"), function(b){
      b.addEventListener("click", function(){
        var o = OPTS[parseInt(b.dataset.i, 10)];
        if (s.multi) {
          var list = answers[s.key] || [];
          var at = list.indexOf(o.k);
          if (at > -1) list.splice(at, 1); else list.push(o.k);
          answers[s.key] = list;
          renderStep();
          return;
        }
        answers[s.key] = o;
        if (s.confirm) {
          Array.prototype.forEach.call(card.querySelectorAll(".ans"), function(x){ x.classList.remove("on"); });
          b.classList.add("on");
          var tip = document.getElementById("tip");
          tip.innerHTML = '<b>Good to know.</b> ' + o.tip; tip.hidden = false;
          var c = document.getElementById("confirm"); c.disabled = false;
          c.onclick = function(){ route(o); };
          return;
        }
        b.classList.add("on", "pop");
        Array.prototype.forEach.call(card.querySelectorAll(".ans"), function(x){ x.disabled = true; });
        setTimeout(function(){ route(o); }, 260);
      });
    });

    function route(o){
        if (s.branch && o.route === "stop")  { renderStop(o.k);  window.scrollTo({top:0,behavior:"smooth"}); return; }
        if (s.branch && o.route === "learn") { renderLearn(o.k); window.scrollTo({top:0,behavior:"smooth"}); return; }
        if (s.branch && o.route === "info")  { answers.diet = [o.k]; renderInfo(o.k, s.key); window.scrollTo({top:0,behavior:"smooth"}); return; }
        if (s.card) { renderCard(s.card, s.key); window.scrollTo({top:0,behavior:"smooth"}); return; }
        advance();
    }

    var go = document.getElementById("go");
    if (go) go.addEventListener("click", advance);
    var back = document.getElementById("back");
    if (back) back.addEventListener("click", goBack);

    var first = card.querySelector(".ans");
    if (first) first.focus({ preventScroll:true });
  }

  /* ---- pick the plan ---- */
  /* ---- LIVE WIRING (v58) ----
     Klaviyo: public company id + the "Quiz leads" list that triggers the Quiz Welcome flow (UhrPS5).
     Shopify: real variant ids and Seal selling-plan ids, read 2026-10-07. Index = TIERS order (2, 4, 6 kits),
     PLAN index = cadence order (4, 8, 12 weeks). GIFT = hidden $0 "Mystery Gift" product, added to
     subscription carts only. */
  var KLAVIYO_CO = "XbYXNA", QUIZ_LIST = "XaSxWt";
  var VARIANT = [48033083195685, 51114734715173, 49986106065189];
  var PLAN = [[690882773285, 691476234533, 691476267301],
              [690929008933, 691476300069, 691476332837],
              [691476496677, 691476529445, 691476562213]];
  var GIFT_VARIANT = 53983061508389;
  var PRODUCT_URL = ["/products/2-prepa-pizza-dough-kits", "/products/4-prepa-pizza-dough-making-kit-815g",
                     "/products/6-prepa-pizza-dough-making-kits"];
  var CRUST_TAG = { hand:"Puffy", thin:"Thin", pan:"Thick-Pan" };   /* matches the old popup's "tag" values */
  function isLive(){ return /(^|\.)prepapizza\.com$/.test(location.hostname) || !!window.Shopify; }
  function ansK(key){ var a = answers[key]; if (!a) return null; return Array.isArray(a) ? a.map(function(x){ return x.k; }).join(",") : a.k; }
  function quizProps(pick, extra){
    var p = {
      quiz_people: ansK("people"), quiz_freq: ansK("freq"), quiz_avoid: ansK("avoid"), quiz_rule: ansK("rule"),
      quiz_oven: ansK("oven"), quiz_exp: ansK("exp"), quiz_want: ansK("want"),
      crust_style: ansK("style"), quiz_source: "Prepa quiz", quiz_date: new Date().toISOString()
    };
    if (ansK("style")) p.tag = CRUST_TAG[ansK("style")];
    if (!pick && answers.people && answers.freq) {          /* no plan screen yet: use what we would recommend */
      var rec = choose(answers.people.pies * answers.freq.per / PER_KIT);
      pick = { ti: TIERS.indexOf(rec.t), ci: rec.t.cad.indexOf(rec.c), q: 1 };
    }
    if (pick) {
      p.quiz_box = String(TIERS[pick.ti].kits);              /* "2" | "4" | "6" — the emails branch on this */
      p.quiz_cadence = String(TIERS[pick.ti].cad[pick.ci].d / 7) + " weeks";
      p.quiz_boxes = pick.q;
      p.quiz_plan_url = "https://www.prepapizza.com" + PRODUCT_URL[pick.ti] + "?selling_plan=" + PLAN[pick.ti][pick.ci];
    }
    for (var k in (extra || {})) p[k] = extra[k];
    for (var j in p) if (p[j] === null || p[j] === undefined) delete p[j];
    return p;
  }
  /* Adds the email to "Quiz leads" (which starts the welcome flow) with every answer as a profile property.
     Fire-and-forget: the visitor never waits on it, and a failure never blocks the quiz. */
  function kSubscribe(email, pick, extra){
    var props = quizProps(pick, extra);
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch(e){}
    if (!isLive()) { try { console.log("[quiz] Klaviyo (prototype, not sent)", email, props); } catch(e){} return; }
    try {
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_CO, {
        method: "POST",
        headers: { "Content-Type": "application/vnd.api+json", "revision": "2024-10-15" },
        body: JSON.stringify({ data: { type: "subscription", attributes: {
          custom_source: "Prepa quiz",
          profile: { data: { type: "profile", attributes: { email: email, properties: props } } }
        }, relationships: { list: { data: { type: "list", id: QUIZ_LIST } } } } }),
        keepalive: true
      });
    } catch(e){}
  }

  function choose(rate){
    var best = null;
    TIERS.forEach(function(t){
      t.cad.forEach(function(c){
        var r = t.kits / (c.d / 30);
        var diff = Math.abs(r - rate);
        if (!best || diff < best.diff - 1e-9 ||
           (Math.abs(diff - best.diff) < 1e-9 && t.kits > best.t.kits)) {
          best = { t:t, c:c, r:r, diff:diff };
        }
      });
    });
    return best;
  }

  function planCard(pick, rate){
    var t = pick.t, c = pick.c;
    var months   = c.d / 30;
    var perMonth = c.p / months;
    var pizzas   = t.kits * PER_KIT;
    var supply   = rate > 0 ? t.kits / rate : 0;
    var listPrice = t.kits * LIST;
    var saveAmt   = listPrice - c.p;
    var savePct   = Math.round(100 * (1 - c.p / listPrice));

    var html =
      '<div class="plan">' +
        '<div class="plan-top">' +
          '<div class="plan-name">' + t.kits + ' kits, every ' + cadLab(c) + '</div>' +
          '<div class="plan-sup">' + pizzas + ' pizzas' +
            ' · about ' + round1(supply) + ' months of pizza nights at your pace</div>' +
        '</div>' +
        '<div class="plan-body">' +
          '<div class="price-row">' +
            '<div class="price num">' + money(perMonth) + '<small> /mo</small></div>' +
            '<div class="price-alt num"><s>' + money(listPrice) + '</s>' +
              '<b>Save ' + money(saveAmt) + ' (' + savePct + '%)</b></div>' +
          '</div>' +
          '<div class="today"><span>Your savings today</span><b class="num">' + money(saveAmt) +
            '</b><em>' + savePct + '% · you save ' + money(saveAmt) + ' vs. ' + t.kits + ' kits at ' + money(LIST) + ' each</em></div>' +
          '<div class="billed num">Billed ' + money(c.p) + ' every ' + cadLab(c) +
            '. Free shipping. Cancel after box two.</div>' +
        '</div>' +
      '</div>';

    return html;
  }

  /* ---- the education branch: no diagnosis, avoiding by choice or on advice ---- */
  /* "what's NOT in it": eight crossed-out badges that pop in one by one */
  function notBadge(sym, label, i){
    return '<div class="nb" style="animation-delay:' + (0.4 + i * 0.35) + 's">' +
      '<span class="nb-i"><span class="nb-s">' + sym + '</span>' +
      '<svg class="nb-x" viewBox="0 0 44 44" aria-hidden="true"><circle cx="22" cy="22" r="19" fill="none" stroke="#d0473e" stroke-width="3"/><path d="M9 35 L35 9" stroke="#d0473e" stroke-width="3" stroke-linecap="round"/></svg></span>' +
      '<b>' + label + '</b></div>';
  }
  var NOTIN = '<div class="notin2"><div class="notin2-h">What is <u>not</u> in it</div><div class="nbs">' +
    notBadge('Fa', 'Added folic acid', 0) + notBadge('Fe', 'Added iron', 1) +
    notBadge('🧴', 'Bleach', 2) + notBadge('Br', 'Bromate', 3) +
    notBadge('⚗', 'Dough conditioners', 4) + notBadge('▢', 'Added sugar', 5) +
    notBadge('⏳', 'Preservatives', 6) + notBadge('◐', 'Dyes', 7) +
  '</div><p class="notin2-f">Store dough often has these. Ours has none.</p></div>';
  function renderLearn(kind){
    hideBelow();
    Array.prototype.forEach.call(prog.children, el => el.className = "");
    say("learn");

    card.innerHTML =
      '<div class="r-kicker" style="color:var(--basil)">Worth thirty seconds</div>' +
      '<h1 class="qtitle">We will not tell you how your body works.</h1>' +
      '<p class="qsub">You know how you feel. We don’t. Here is what is in the bag.</p>' +

      '<div class="ing"><div class="ing-h">Made with organic ingredients<span class="contains">Contains wheat</span></div>' + SIX + '</div>' +
      NOTIN +

      '<div class="ferm"><div class="ferm-h">We teach real fermentation</div>' +
        '<div class="ferm-row"><span>Fast store dough</span><i><b class="f1"></b></i><em>about 1 hour</em></div>' +
        '<div class="ferm-row"><span>Prepa method</span><i><b class="f2"></b></i><em>slow rise, up to 2 days</em></div>' +
        '<p>A slow rise breaks down more of the dough before you eat it. ' +
        'It is why some people do better with slow-fermented dough, like sourdough. We teach you how.</p>' +
        '<p class="ferm-note">Not for celiac. Fermenting wheat is still wheat.</p></div>' +
      '<div class="reframe" style="margin-top:16px"><b>The Italy thing.</b> ' +
        'People who cannot eat bread at home eat pizza in Italy and feel fine. ' +
        'Nobody knows why. Our flour comes from there.</div>' +

      '<div class="reframe" style="margin-top:12px"><b>Straight talk.</b> ' +
        'Most people only ever ate the cheap kind. Bleached flour. Added iron. ' +
        'Ours is six things you can read.</div>' +

      '<div class="fit" style="margin-top:14px"><b>Try it. Not right? We refund you.</b></div>' +

      '<button type="button" class="back" id="back">← Back</button>';
    autoNext(19000, function(){ advanceFrom("why"); });
    document.getElementById("back").addEventListener("click", goBack);
  }

  /* ---- straight answers for allergies and food rules (quiz card + result page) ---- */
  var ING_I = {
    flour:'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M9 8 h14 l2 18 h-18 Z" fill="#f5efdf" stroke="#253230" stroke-width="1.6"/><path d="M9 8 q7 4 14 0" fill="none" stroke="#253230" stroke-width="1.6"/><text x="16" y="21" font-size="7" text-anchor="middle" font-weight="700" fill="#d0473e" font-family="sans-serif">00</text></svg>',
    grain:'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 28 V8" stroke="#253230" stroke-width="1.6"/><g fill="#e3a857" stroke="#253230" stroke-width="1"><ellipse cx="12.5" cy="11" rx="3" ry="4.5" transform="rotate(-25 12.5 11)"/><ellipse cx="19.5" cy="11" rx="3" ry="4.5" transform="rotate(25 19.5 11)"/><ellipse cx="12.5" cy="18" rx="3" ry="4.5" transform="rotate(-25 12.5 18)"/><ellipse cx="19.5" cy="18" rx="3" ry="4.5" transform="rotate(25 19.5 18)"/></g></svg>',
    olive:'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M6 24 q10 -2 20 -16" stroke="#253230" stroke-width="1.6" fill="none"/><ellipse cx="13" cy="16" rx="4.5" ry="6" fill="#6b8e3a" transform="rotate(-30 13 16)"/><ellipse cx="22" cy="12" rx="2.5" ry="5" fill="#0f855b" transform="rotate(40 22 12)"/></svg>',
    salt:'<svg viewBox="0 0 32 32" aria-hidden="true"><g fill="#fff" stroke="#253230" stroke-width="1.4"><rect x="7" y="15" width="7" height="7" rx="1" transform="rotate(12 10 18)"/><rect x="17" y="11" width="8" height="8" rx="1" transform="rotate(-10 21 15)"/><rect x="15" y="20" width="6" height="6" rx="1" transform="rotate(20 18 23)"/></g></svg>',
    yeast:'<svg viewBox="0 0 32 32" aria-hidden="true"><g fill="#f3fc81" stroke="#253230" stroke-width="1.4"><circle cx="12" cy="18" r="6"/><circle cx="21" cy="13" r="4.5"/><circle cx="21" cy="23" r="3"/></g></svg>',
    honey:'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 5 C21 13 24 16 24 20 a8 8 0 0 1 -16 0 C8 16 11 13 16 5 Z" fill="#f2b705" stroke="#253230" stroke-width="1.5"/></svg>',
    malt:'<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M7 14 q9 -5 18 0 l-3 12 a2 2 0 0 1 -2 1.6 h-8 a2 2 0 0 1 -2 -1.6 Z" fill="#e3a857" stroke="#253230" stroke-width="1.5"/><path d="M9 13 q7 -9 14 0" fill="none" stroke="#253230" stroke-width="1.5"/><circle cx="13" cy="8" r="1.3" fill="#b9772f"/><circle cx="18" cy="6.4" r="1.1" fill="#b9772f"/><circle cx="22" cy="9" r="1" fill="#b9772f"/></svg>'
  };
  var SIX = '<ul class="six6">' +
      '<li>' + ING_I.flour + '<b>Milled 00</b><span>Italian grown wheat</span></li>' +
      '<li>' + ING_I.olive + '<b>Olive oil</b><span>Tuscan</span></li>' +
      '<li>' + ING_I.salt + '<b>Sea salt</b><span>Nothing added</span></li>' +
      '<li>' + ING_I.yeast + '<b>Dry yeast</b><span>For the rise</span></li>' +
      '<li>' + ING_I.honey + '<b>Honey</b><span>Own packet, optional</span></li>' +
      '<li>' + ING_I.malt + '<b>Diastatic malt</b><span>Browning and rise</span></li>' +
    '</ul>' +
    '<p class="get-you" style="margin:0 14px 12px"><b>Also in the box:</b> semolina, for dusting and stretching. ' +
    'Not mixed into the dough.</p>';
  var INFO = {
    allergy: { m:"yes", h:"No nuts. No dairy. No eggs.",
      t:"No nuts. No dairy. No eggs.",
      s:"Manufactured in-house, fresh to order. Not co-packed at a company that runs multiple products." },
    vegan:   { m:"info", h:"The dough is plant-based.",
      t:"The dough is plant-based. The honey is optional.",
      s:"Use sugar or agave instead. Works the same." },
    kosher:  { m:"info", h:"Every ingredient is certified kosher.",
      t:"Every ingredient is certified kosher. We hold the certificates.",
      s:"We hold all six certificates. The kit itself is not separately certified." },
    halal:   { m:"info", h:"No certificate. Here is everything in it.",
      t:"No halal certificate. Here is everything in it.",
      s:"No meat. No gelatin. No alcohol. No animal fat." },
    clean:   { m:"yes", h:"Six things. That is the whole list.",
      t:"Six things. That is the whole list.",
      s:"No conditioners. No bleach. No sugar. No preservatives. No dyes." }
  };

  /* "free from" badges: they pop in one by one while the timer bar moves */
  function freeBadge(icon, label, i){
    return '<div class="free" style="animation-delay:' + (0.5 + i * 0.9) + 's">' + icon +
      '<svg class="slash" viewBox="0 0 56 56" aria-hidden="true"><circle cx="28" cy="28" r="25" fill="none" stroke="#d0473e" stroke-width="4"/><path d="M11 45 L45 11" stroke="#d0473e" stroke-width="4" stroke-linecap="round"/></svg>' +
      '<b>' + label + '</b></div>';
  }
  var FREE = '<div class="frees">' +
    freeBadge('<svg class="fi" viewBox="0 0 56 56" aria-hidden="true"><path d="M28 12 c10 0 16 8 16 18 c0 8 -7 14 -16 14 s-16 -6 -16 -14 c0 -10 6 -18 16 -18 Z" fill="#c68b4e" stroke="#253230" stroke-width="2"/><path d="M28 16 v26 M20 22 q8 6 16 0 M20 32 q8 6 16 0" stroke="#8a5a2b" stroke-width="1.6" fill="none"/></svg>', "No nuts", 0) +
    freeBadge('<svg class="fi" viewBox="0 0 56 56" aria-hidden="true"><path d="M20 10 h16 v6 l4 8 v22 a2 2 0 0 1 -2 2 h-20 a2 2 0 0 1 -2 -2 v-22 l4 -8 Z" fill="#fff" stroke="#253230" stroke-width="2"/><rect x="16" y="28" width="24" height="10" fill="#dbe9f5"/></svg>', "No dairy", 1) +
    freeBadge('<svg class="fi" viewBox="0 0 56 56" aria-hidden="true"><path d="M28 9 c9 0 15 14 15 24 a15 15 0 0 1 -30 0 c0 -10 6 -24 15 -24 Z" fill="#fff5dc" stroke="#253230" stroke-width="2"/></svg>', "No eggs", 2) +
  '</div>';
  /* vegan: the honey card flips to show the swap. Flips on its own, or tap it. */
  var HONEY_FLIP = '<button type="button" class="flip" id="flip" aria-label="Honey is optional. Tap to see the swap.">' +
    '<span class="flip-in">' +
      '<span class="flip-f">' +
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 5 C21 13 24 16 24 20 a8 8 0 0 1 -16 0 C8 16 11 13 16 5 Z" fill="#f2b705" stroke="#253230" stroke-width="1.5"/></svg>' +
        '<span><b>Honey comes in its own packet</b><em>It is there. You don\'t have to use it.</em></span>' +
        '<i>Swap ↻</i></span>' +
      '<span class="flip-b">' +
        '<span class="swaps">' +
          '<span class="sw"><svg viewBox="0 0 32 32" aria-hidden="true"><g fill="#fff" stroke="#253230" stroke-width="1.5"><rect x="6" y="12" width="10" height="10" rx="1.5"/><rect x="16" y="9" width="10" height="10" rx="1.5"/></g></svg><b>Sugar</b></span>' +
          '<span class="sw-or">or</span>' +
          '<span class="sw"><svg viewBox="0 0 32 32" aria-hidden="true"><rect x="11" y="4" width="10" height="5" rx="1.5" fill="#0f855b"/><path d="M9 11 h14 v15 a3 3 0 0 1 -3 3 h-8 a3 3 0 0 1 -3 -3 Z" fill="#f3d38a" stroke="#253230" stroke-width="1.5"/><path d="M13 19 q3 -5 6 0 q-3 5 -6 0 Z" fill="#6b8e3a"/></svg><b>Agave</b></span>' +
        '</span>' +
        '<span><b>Swap it at home</b><em>Use sugar or agave instead. Same dough. Fully plant-based.</em></span>' +
      '</span>' +
    '</span></button>';
  function renderInfo(k, fromKey){
    hideBelow();
    say("info");
    var a = INFO[k];
    card.innerHTML =
      '<div class="r-kicker">Straight answer</div>' +
      '<h1 class="qtitle">' + a.h + '</h1>' +
      '<p class="qsub">' + a.s + '</p>' +
      (k === "allergy" ? FREE : '') +
      (k === "vegan" ? HONEY_FLIP : '') +
      '<div class="ing"><div class="ing-h">Made with organic ingredients' +
        (k === "allergy" ? '<span class="contains">Contains wheat</span>' : '') + '</div>' + SIX + '</div>' +
      '<button type="button" class="back" id="back">← Back</button>';
    autoNext(k === "allergy" ? 8000 : k === "vegan" ? 9000 : 6500, function(){ advanceFrom(fromKey); });
    var fl = document.getElementById("flip");
    if (fl) {
      fl.addEventListener("click", function(){ fl.classList.toggle("on"); });
      [1800, 5200].forEach(function(ms, i){ later(ms, function(){ if (document.getElementById("flip") === fl) fl.classList.toggle("on", i === 0); }); });
      later(7000, function(){ if (document.getElementById("flip") === fl) fl.classList.add("on"); });
    }
    document.getElementById("back").addEventListener("click", goBack);
  }

  /* ---- in-quiz cards: plant a belief or answer a doubt before the price ---- */
  var HELP_ICO = {
    play:'<svg width="34" height="34" viewBox="0 0 34 34" aria-hidden="true"><rect x="2" y="6" width="30" height="22" rx="4" fill="#253230"/><path d="M14 12 L23 17 L14 22 Z" fill="#f3fc81"/></svg>',
    page:'<svg width="34" height="34" viewBox="0 0 34 34" aria-hidden="true"><rect x="7" y="3" width="20" height="28" rx="3" fill="#fff" stroke="#253230" stroke-width="1.6"/><path d="M11 10 h12 M11 15 h12 M11 20 h8" stroke="#d0473e" stroke-width="1.8" stroke-linecap="round"/></svg>',
    phone:'<svg width="34" height="34" viewBox="0 0 34 34" aria-hidden="true"><rect x="9" y="2" width="16" height="30" rx="4" fill="#0f855b"/><rect x="12" y="6" width="10" height="18" rx="1.5" fill="#fff"/><circle cx="17" cy="28" r="1.6" fill="#fff"/></svg>'
  };
  /* ---- slider question: a different format so the quiz doesn't feel like one long list ---- */
  function wantLabel(v){ return v <= 3 ? "Nice to have" : v <= 7 ? "It would be great" : "It's a must"; }
  function renderSlider(s, head){
    var v = (answers[s.key] && answers[s.key].k) || 7;
    card.innerHTML = head.replace('<div class="answers">', '') +
      '<div class="sl">' +
        '<div class="sl-v"><strong class="num" id="sl-n">' + v + '</strong><span id="sl-l">' + wantLabel(v) + '</span></div>' +
        '<input type="range" id="sl-in" min="1" max="10" step="1" value="' + v + '" aria-label="1 to 10">' +
        '<div class="sl-ends"><span>1 · Nice to have</span><span>10 · A must</span></div>' +
      '</div>' +
      '<p class="fine" id="sl-hint">Slide to your number. We move on when you let go.</p>' +
      '<button type="button" class="back" id="back">← Back</button>';
    onQuestion = true;
    say(s.key);
    var inp = document.getElementById("sl-in");
    function paint(){ var n = +inp.value; document.getElementById("sl-n").textContent = n;
      document.getElementById("sl-l").textContent = wantLabel(n);
      inp.style.setProperty("--p", ((n - 1) / 9 * 100) + "%"); }
    inp.addEventListener("input", paint); paint();
    var slT = null;
    inp.addEventListener("change", function(){
      var n = +inp.value; answers[s.key] = { k:n, t:n + "/10" };
      document.getElementById("sl-hint").textContent = "Got it: " + n + "/10.";
      clearTimeout(slT);
      slT = setTimeout(function(){ if (document.getElementById("sl-in") === inp) renderQuality(n); }, 900);
    });
    document.getElementById("back").addEventListener("click", function(){
      goBack(); return;
    });
    inp.focus({ preventScroll:true });
  }
  /* ---- "Fans Just Like You" loader: a loading bar that fills while real comments slide past,
         then it moves on by itself. Mirrors the PDP section of the same name.
         FINAL BUILD: swap the text cards for the 7 PDP comment screenshots
         (shop_images 38, 24, 25, 27, 31, 23, 28 .webp) — same order, same autoplay. ---- */
  function renderFans(fromKey){
    hideBelow(); say(null);
    var keys = ["michele","pam","matthew","eric","danny","cheryl","kevin","gordon","wb","ian","andrew","todd","mike"];
    var cards = keys.map(function(k){ var r = R[k];
      return '<figure class="fan"><div class="fan-top"><span class="fan-av" aria-hidden="true">' + r.n.charAt(0) + '</span>' +
        '<div><b>' + r.n + '</b><span class="vf">' + r.src + '</span></div></div>' +
        '<p>“' + r.q + '”</p>' + stars() + '</figure>'; }).join('');
    card.innerHTML =
      '<div class="r-kicker">Fans just like you</div>' +
      '<h1 class="qtitle">Great pizza starts with the dough.</h1>' +
      '<div class="myth">' +
        '<div class="myth-row"><span class="x">✕</span><s>Better cheese</s></div>' +
        '<div class="myth-row"><span class="x">✕</span><s>New sauce</s></div>' +
        '<div class="myth-row"><span class="x">✕</span><s>Fancy oven</s></div>' +
        '<div class="myth-row win"><span class="ok">✓</span><b>Better dough</b></div>' +
      '</div>' +
      '<p class="myth-say"><b>Toppings can\'t fix bad dough.</b></p>' +
      '<div class="split grow"><div class="split-bar"><span class="d" id="dough-bar"><em id="dough-n">Your dough: 0%</em></span><span class="t"></span></div>' +
        '<p class="split-cap">Toppings: 15% ↑</p>' +
        '<p>Dough is most of your pizza.</p></div>' +
      '<div class="stats2">' +
        '<div><div class="big-stat num">300,000+</div><p>pizzas made at home</p></div>' +
        '<div><div class="big-stat num">6,000+</div><p>' + stars() + ' 4.99 average</p></div>' +
      '</div>' +
      '<div class="fans" aria-label="Customer comments"><div class="fans-track" id="fans-track">' + cards + cards + '</div></div>' +
      '<div class="bar" style="margin-top:18px"><div class="bar-t"><span id="fans-l">Finding your size…</span><em id="fans-p">0%</em></div><i><b id="fans-b"></b></i></div>' +
      '<button type="button" class="back" id="fans-skip">Skip</button>';
    /* the dough bar stretches out to 85% and counts up as it goes */
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      var db = document.getElementById("dough-bar"); if (db) db.style.flexBasis = "85%";
    }); });
    var dn = 0, dT = setInterval(function(){
      var el = document.getElementById("dough-n"); if (!el) { clearInterval(dT); return; }
      if (PAUSED) return;
      dn = Math.min(85, dn + 3); el.textContent = "Your dough: " + dn + "%";
      if (dn >= 85) { clearInterval(dT); el.parentNode.classList.add("hit"); }
    }, 45);
    var track = document.getElementById("fans-track"), i = 0, n = keys.length;
    var slide = setInterval(function(){
      if (PAUSED) return;
      i++; var w = track.children[0].getBoundingClientRect().width + 12;
      track.style.transform = "translateX(" + (-i * w) + "px)";
      if (i >= n) { setTimeout(function(){ track.style.transition = "none"; i = 0; track.style.transform = "translateX(0)";
        void track.offsetWidth; track.style.transition = ""; }, 520); }
    }, 1500);
    var pct = 0, labels = ["Finding your size…", "Counting your pizza nights…", "Almost ready…"];
    var load = setInterval(function(){
      if (PAUSED) return;
      pct += 1;
      var b = document.getElementById("fans-b"); if (!b) { clearInterval(load); clearInterval(slide); return; }
      b.style.width = pct + "%"; document.getElementById("fans-p").textContent = pct + "%";
      document.getElementById("fans-l").textContent = labels[Math.min(2, Math.floor(pct / 34))];
      if (pct >= 100) { done(); }
    }, 95);
    function done(){ clearInterval(load); clearInterval(slide); advanceFrom(fromKey); }
    document.getElementById("fans-skip").addEventListener("click", done);
  }

  /* ---- auto-advance: no "Keep going" clicks. A thin bar fills, then the funnel moves on.
         Each timer is tied to its own bar, so a Back click or re-render cancels it. ---- */
  /* ---- TEST ONLY: pause every timer so each page can be read. Remove the button before launch. ---- */
  var PAUSED = false;
  function later(ms, fn){
    var left = ms, t = setInterval(function(){
      if (PAUSED) return; left -= 100; if (left <= 0) { clearInterval(t); fn(); } }, 100);
  }
  /* test pause button removed for launch (v57) */

  /* Every page that moves on by itself also offers a way to push on. The timer is the default
     so nobody has to click; the skip is for people who read faster than the bar moves. */
  function autoNext(ms, go){
    /* v59: 1.6x longer, and it stops for good the moment the visitor touches, scrolls or
       hovers the card, so nobody loses a screen they are still reading. "Continue" always works. */
    ms = Math.round(ms * 1.6);
    var id = "auto" + Math.random().toString(36).slice(2), fired = false, held = false;
    function fire(){ if (fired) return; fired = true; go(); }
    card.insertAdjacentHTML("beforeend",
      '<div class="autorow"><div class="auto" id="' + id + '"><b style="animation-duration:' + ms + 'ms"></b></div>' +
      '<button type="button" class="skipb" id="' + id + '-s">Continue →</button></div>');
    function hold(e){
      if (held || fired) return;
      if (e && e.target && e.target.id === id + "-s") return;
      held = true;
      var bar = document.getElementById(id); if (bar) bar.style.visibility = "hidden";
    }
    ["pointerdown", "touchstart", "wheel", "mouseenter"].forEach(function(ev){ card.addEventListener(ev, hold, { passive: true, once: true }); });
    window.addEventListener("scroll", function sc(){ hold(); window.removeEventListener("scroll", sc); }, { passive: true });
    later(ms, function(){ if (!held && document.getElementById(id)) fire(); });
    document.getElementById(id + "-s").addEventListener("click", fire);
  }
  /* ---- after the slider: why the quality matters. Low scores also get asked what matters more. ---- */
  /* ---- after "What matters most": the reassurance is written for THAT answer.
         Four answers, four proofs. The quality block (best ingredients, packed fresh)
         stays on all four, because it is the reason any of them are true. ---- */
  var QBLOCK =
      '<ul class="helps">' +
        '<li><svg width="34" height="34" viewBox="0 0 34 34" aria-hidden="true"><circle cx="17" cy="17" r="14" fill="#fff" stroke="#253230" stroke-width="1.8"/><path d="M3 17 h28 M17 3 q-8 14 0 28 M17 3 q8 14 0 28" stroke="#253230" stroke-width="1.5" fill="none"/><circle cx="25" cy="9" r="4" fill="#d0473e"/></svg>' +
          '<div><b>The best ingredients we could find</b><span>The same ones the best pizzerias use.</span></div></li>' +
        '<li><svg width="34" height="34" viewBox="0 0 34 34" aria-hidden="true"><path d="M5 11 L17 5 L29 11 V25 L17 31 L5 25 Z" fill="#fff" stroke="#253230" stroke-width="1.8"/><path d="M5 11 L17 17 L29 11 M17 17 V31" stroke="#253230" stroke-width="1.8" fill="none"/><path d="M23 2 q2 2 0 4 M27 3 q2 2 0 4" stroke="#0f855b" stroke-width="1.6" fill="none"/></svg>' +
          '<div><b>Packed fresh when you order</b><span>Not months on a store shelf.</span></div></li>' +
      '</ul>' +
      '<div class="shelf">' +
        '<div class="shelf-row"><span>Store dough</span><i><b class="old"></b></i><em>months on a shelf</em></div>' +
        '<div class="shelf-row"><span>Prepa</span><i><b class="new"></b></i><em>packed when you order</em></div>' +
      '</div>';

  function renderQuality(kind){
    hideBelow();
    answers.priority = answers.want || { k:kind, t:kind };
    var k = answers.want ? answers.want.k : kind;
    /* the voice under the page answers the same doubt the page does */
    SAY.quality = { taste:"danny", price:"gordon", time:"eric", try:"cheryl" }[k] || "todd";
    say("quality");

    var top, ms = 8500;

    if (k === "price") {
      var rate = answers.people.pies * answers.freq.per / PER_KIT;
      var pk = choose(rate);
      var pp = pk.c.p / (pk.t.kits * PER_KIT);
      top =
        '<div class="r-kicker">Your money</div>' +
        '<h1 class="qtitle">Cheaper than delivery.</h1>' +
        '<div class="big-stat num">' + money(pp) + '</div>' +
        '<p class="qsub" style="margin-top:4px">a pizza. Shipping is free.</p>' +
        '<div class="fit"><b>Nothing locked in.</b> Keep box two, then stop whenever.</div>';

    } else if (k === "time") {
      top =
        '<div class="r-kicker">Your time</div>' +
        '<h1 class="qtitle">15 minutes of work.</h1>' +
        '<p class="qsub">The rest is the dough resting. Not you.</p>' +
        '<div class="chips" style="margin-top:14px"><span class="chip">Mix</span>' +
          '<span class="chip">Fold</span><span class="chip">Bake</span>' +
          '<span class="chip"><em>total hands on:</em> 15 min</span></div>' +
        '<div class="fit"><b>Freeze the rest.</b> Pull one out any night.</div>';

    } else if (k === "try") {
      top =
        '<div class="r-kicker">No pressure</div>' +
        '<h1 class="qtitle">Start small. See how it goes.</h1>' +
        '<p class="qsub">Keep box two. Then stop whenever.</p>' +
        '<div class="guar" style="margin-top:16px"><svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true"><path d="M20 3 L34 8 V19 C34 28 27 34 20 37 C13 34 6 28 6 19 V8 Z" fill="#0f855b"/><path d="M13 20 l5 5 l9 -10" stroke="#fff" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<div><b>Not right? We make it right.</b><span>100% satisfaction guaranteed.</span></div></div>';
      ms = 8000;

    } else {
      top =
        '<div class="r-kicker">Good answer</div>' +
        '<h1 class="qtitle">Then you are in the right place.</h1>' +
        '<p class="qsub">The same brands and the same recipe the best pizzerias in the world use.</p>';
      ms = 8000;
    }

    card.innerHTML = top +
      '<p class="qsub" style="margin-top:18px"><b>In every bag:</b></p>' +
      QBLOCK +
      '<p class="qsub" style="margin-top:12px"><b>That is pizzeria taste at home.</b></p>' +
      '<button type="button" class="back" id="back">← Back</button>';
    document.getElementById("back").addEventListener("click", backToSlider);
    autoNext(ms, function(){ advanceFrom("want"); });
  }

  /* ---- after "where are you cooking it": the same dough at their temperature.
         High heat is the first thing a pizza-oven owner asks, and nothing answered it. ---- */
  var OVENS = [
    { k:"oven",   n:"Pizza oven",  t:"800–950°F" },
    { k:"kamado", n:"Kamado",      t:"700–800°F" },
    { k:"grill",  n:"Grill",       t:"600–700°F" },
    { k:"home",   n:"Home oven",   t:"450–550°F" }
  ];
  function renderOven(fromKey){
    hideBelow();
    var k = answers.oven ? answers.oven.k : "home";
    SAY.oven = { oven:"michele", home:"cheryl", grill:"kevin", kamado:"matthew" }[k] || "michele";
    say("oven");

    var C = {
      oven:   { kick:"High heat", head:"Built for 900°F.",
                sub:"Sixty seconds and it is done. That is what this flour is milled for.",
                fit:"<b>The oven is the fun part. It is not why it tastes good.</b> That is the dough. Launch it raw, don\'t par-bake." },
      kamado: { kick:"Kamado", head:"High, even heat.",
                sub:"Exactly what this dough wants.",
                fit:"<b>Great kit. It is not the secret.</b> The dough is. Lid down, let it come up to temp." },
      grill:  { kick:"On the grill", head:"Hotter than any home oven.",
                sub:"That works in your favour.",
                fit:"<b>A grill is a bonus, not a requirement.</b> The dough does the work. Gas or charcoal, both covered." },
      home:   { kick:"Your home oven", head:"500°F is plenty.",
                sub:"A cookie sheet is enough. No stone. No steel.",
                fit:"<b>Nothing to buy. Nothing to upgrade.</b> Equipment adds fun, not flavour. Hottest setting, middle rack." }
    }[k];

    var mine = OVENS.filter(function(o){ return o.k === k; })[0] || OVENS[3];
    card.innerHTML =
      '<div class="r-kicker">' + C.kick + '</div>' +
      '<h1 class="qtitle">' + C.head + '</h1>' +
      '<p class="qsub">' + C.sub + '</p>' +
      '<div class="big-stat num">' + mine.t + '</div>' +
      '<p class="qsub" style="margin-top:4px">where you are cooking</p>' +
      '<div class="temps">' +
        OVENS.map(function(o){
          return '<div class="tmp' + (o.k === k ? ' on' : '') + '"><b>' + o.n + '</b><span>' + o.t + '</span></div>';
        }).join('') +
      '</div>' +
      '<p class="myth-say" style="margin-top:16px"><b>Same dough every time.</b> You change the bake time, not the recipe.</p>' +
      '<p class="qsub" style="margin-top:8px">Better equipment makes it <b>easier</b>. It does not make it <b>taste better</b>. That is the dough\'s job.</p>' +
      '<div class="fit">' + C.fit + '</div>' +
      '<button type="button" class="back" id="back">← Back</button>';
    document.getElementById("back").addEventListener("click", goBack);
    autoNext(8000, function(){ advanceFrom(fromKey); });
  }

  /* ---- what one kit makes. Awareness only: it shows the spread so nobody has to guess,
         and it does not change a single number anywhere else in the quiz. ---- */
  function renderKit(fromKey){
    hideBelow();
    var k = answers.style ? answers.style.k : "hand";
    SAY.kit = { hand:"kevin", thin:"matthew", pan:"gordon" }[k] || "kevin";
    say("kit");
    var rows = SIZES[k], art = SIZE_ART[k];
    var STEP_MS = 105, seq = [];   /* one pizza lands every 105ms and the count ticks with it */
    /* "six is too many for us" is the objection Q1 just surfaced — answer it here, by name,
       rather than leaving it to the build loader where nobody is looking. */
    var eat = answers.people ? answers.people.pies : PER_KIT, spare = "";
    if (PER_KIT - eat >= 2) {   /* one spare ball is not worth a callout */
      spare = '<div class="freeze-note" style="margin-top:12px"><b>Too many for one night?</b> ' +
              'Bake ' + eat + ' tonight, freeze the other ' + (PER_KIT - eat) + '. ' +
              'Frozen dough keeps up to 6 months — pull one out any night.</div>';
    }
    card.innerHTML =
      '<div class="r-kicker">Good to know</div>' +
      '<h1 class="qtitle">One kit. Six 12-inch pizzas.</h1>' +
      '<p class="qsub">That is the standard. Smaller gets you more, bigger gets you fewer.</p>' +
      '<div class="gs-h" style="margin-top:18px;border-radius:10px 10px 0 0">' +
        STYLE_NAME[k] + ' — what one kit makes</div>' +
      '<div class="sizeg">' +
        rows.map(function(o, ri){
          var icons = "";
          for (var i = 0; i < o.yield; i++) {
            icons += '<span class="ic" style="animation-delay:' + (STEP_MS * (seq.length) + 240) + 'ms">' + art[o.k] + '</span>';
            seq.push(ri);
          }
          return '<div class="sz" id="sz' + ri + '"><div class="sz-h"><b>' + o.t + '</b>' +
                 '<em id="szc' + ri + '">0 per kit</em></div>' +
                 '<div class="sz-icons ' + o.k + '">' + icons + '</div></div>';
        }).join('') +
      '</div>' +
      '<p class="myth-say" style="margin-top:16px"><b>Same bag, any style.</b> Hand tossed, thin or deep pan — one dough does all three.</p>' +
      '<div class="fit"><b>15 minutes of hands-on work.</b> The rest is the dough resting, not you.</div>' +
      spare +
      '<button type="button" class="back" id="back">← Back</button>';
    document.getElementById("back").addEventListener("click", goBack);

    /* count up with the pizzas as they land */
    var at = 0, tally = [0, 0, 0];
    var tick = setInterval(function(){
      if (PAUSED) return;
      var em = document.getElementById("szc0");
      if (!em) { clearInterval(tick); return; }          /* page moved on */
      if (at >= seq.length) {
        clearInterval(tick);
        rows.forEach(function(o, ri){ var el = document.getElementById("sz" + ri); if (el) el.classList.add("done"); });
        return;
      }
      var ri = seq[at++];
      tally[ri]++;
      var c = document.getElementById("szc" + ri);
      if (c) {
        c.textContent = tally[ri] + " per kit";
        c.classList.add("bump");
        setTimeout(function(){ c.classList.remove("bump"); }, 180);
      }
    }, STEP_MS);

    autoNext(8500, function(){ clearInterval(tick); advanceFrom(fromKey); });
  }

  function backToSlider(){ goBack(); }
  function renderCard(kind, fromKey){
    if (kind === "proof") { renderFans(fromKey); return; }
    if (kind === "quality") { renderQuality(answers.want ? answers.want.k : "taste"); return; }
    if (kind === "oven") { renderOven(fromKey); return; }
    if (kind === "kit") { renderKit(fromKey); return; }
    hideBelow();
    var html;
    if (kind === "proof") {
      say("freq");
      html =
        '<div class="r-kicker">Good to know</div>' +
        '<h1 class="qtitle">Great pizza starts with the dough.</h1>' +
        '<p class="qsub">Most people try to fix bad pizza with better cheese, sauce or a new oven. ' +
          'But the dough is most of the pizza. Start there.</p>' +
        '<div class="split"><div class="split-bar"><span class="d">Dough: 85%</span><span class="t">Toppings</span></div>' +
          '<p>Dough is most of your pizza.</p></div>' +
        '<div class="big-stat num">300,000+</div>' +
        '<p class="qsub" style="margin-top:6px">pizzas made by home cooks with a Prepa kit.</p>';
    } else {
      var k = answers.exp.k;
      SAY.help = { never:"pam", flop:"michele", meh:"matthew" }[k];
      say("help");
      var C = {
        never: { kick:"Your first time", head:"You won't guess at anything.",
                 sub:"Every step is already decided.",
                 why:"<b>You just follow along.</b> Bag and lessons made to go together." },
        flop:  { kick:"Why it failed", head:"It wasn't you. It was the recipe.",
                 sub:"Wrong flour, wrong recipe. Both fixed.",
                 why:"<b>You get both this time.</b> And a person to call if it fights you." },
        meh:   { kick:"The missing piece", head:"Good dough. Not pizzeria dough.",
                 sub:"Right ingredients, and a recipe built for them.",
                 why:"<b>Same hands, same oven.</b> The pairing is what changes." }
      }[k];
      var I = {
        bag:'<svg viewBox="0 0 120 96" aria-hidden="true"><path d="M34 14 h52 l8 74 h-68 Z" fill="#f5efdf" stroke="#253230" stroke-width="3"/><path d="M34 14 q26 12 52 0" fill="none" stroke="#253230" stroke-width="3"/><circle cx="60" cy="54" r="15" fill="#d0473e"/><path d="M52 54 l6 6 l10 -12" stroke="#fff" stroke-width="3.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M96 20 l4 -8 M104 30 l8 -4 M100 42 l9 1" stroke="#f2b705" stroke-width="3" stroke-linecap="round"/></svg>',
        class:'<svg viewBox="0 0 120 96" aria-hidden="true"><rect x="6" y="14" width="66" height="46" rx="7" fill="#253230"/><path d="M32 26 L50 37 L32 48 Z" fill="#f3fc81"/><rect x="66" y="30" width="46" height="58" rx="5" fill="#fff" stroke="#253230" stroke-width="3"/><path d="M75 45 h28 M75 55 h28 M75 65 h20 M75 75 h24" stroke="#d0473e" stroke-width="3" stroke-linecap="round"/></svg>',
        phone:'<svg viewBox="0 0 120 96" aria-hidden="true"><rect x="42" y="6" width="36" height="84" rx="9" fill="#0f855b"/><rect x="48" y="16" width="24" height="54" rx="3" fill="#fff"/><circle cx="60" cy="80" r="4" fill="#fff"/><path d="M84 30 q10 10 0 20 M92 24 q16 16 0 32" stroke="#0f855b" stroke-width="3.5" fill="none" stroke-linecap="round"/></svg>'
      };
      /* the three shared slides are "what comes with it" — the personal answer is the
         payoff block above, which stays on screen instead of rotating away */
      var SLIDES = [
        ["bag", "The kit", "Six dough balls per bag. Everything measured."],
        ["class", "Video and written masterclass", "Every step. Watch it or read it."],
        ["phone", "Live support you can call", "Call (800) 913-8851. We help you fix it."]
      ];
      var FLAT = '<svg viewBox="0 0 120 70" aria-hidden="true"><ellipse cx="60" cy="52" rx="44" ry="11" fill="#e4d4ae" stroke="#b9772f" stroke-width="2.5"/><path d="M22 50 q12 -5 20 1 q10 5 20 -2 q12 -6 22 2" fill="none" stroke="#b9772f" stroke-width="2"/></svg>';
      var DOME = '<svg viewBox="0 0 120 70" aria-hidden="true"><path d="M16 56 a44 36 0 0 1 88 0 Z" fill="#f0dcae" stroke="#0f855b" stroke-width="2.5"/><path d="M34 40 q12 -9 24 -3 q10 5 20 -3" fill="none" stroke="#d9c38c" stroke-width="2"/></svg>';
      var PAYOFF = {
        flop:
          '<div class="po"><div class="po-2">' +
            '<div class="po-c bad">' + FLAT + '<b>Grocery store flour</b><span>And a recipe written for a different bag</span></div>' +
            '<div class="po-c good">' + DOME + '<b>What pizzerias use</b><span>And the recipe built for it</span></div>' +
          '</div>' +
          '<p class="po-note"><b>That is the whole fix.</b> Right ingredients, and a recipe made for those ingredients.</p></div>',
        never:
          '<div class="po"><div class="po-steps">' +
            [["1","Open the bag"],["2","Add water"],["3","Let it rest"],["4","Bake"]].map(function(x, i){
              return '<div class="po-st" style="animation-delay:' + (0.2 + i * 0.5) + 's"><i>' + x[0] + '</i><b>' + x[1] + '</b></div>';
            }).join('') +
          '</div></div>',
        meh:
          '<div class="po"><div class="po-eq">' +
            '<div><b>Pro ingredients</b><span>The brands the best pizzerias use</span></div>' +
            '<div class="op" aria-hidden="true">+</div>' +
            '<div><b>Its own recipe</b><span>Written for those exact ingredients</span></div>' +
            '<div class="op" aria-hidden="true">=</div>' +
            '<div class="win"><b>Pizzeria dough</b><span>Same hands, same oven</span></div>' +
          '</div>' +
          '<p class="po-note"><b>Not what is on the grocery store shelf.</b> That pairing is the part you cannot buy separately.</p></div>'
      }[k];
      html =
        '<div class="r-kicker">' + C.kick + '</div>' +
        '<h1 class="qtitle">' + C.head + '</h1>' +
        '<p class="qsub">' + C.sub + '</p>' +
        PAYOFF +
        '<div class="gs"><div class="gs-h">What comes with it</div>' +
          '<div class="gs-list">' +
            SLIDES.map(function(x){ return '<div class="gs-row">' + I[x[0]] + '<div><b>' + x[1] + '</b><span>' + x[2] + '</span></div></div>'; }).join('') +
          '</div>' +
        '</div>';
      html += '<div class="fit" style="margin-top:14px">' + C.why + '</div>' +
              '<p class="get-you" style="margin:12px 0 0"><b>You add:</b> water, a bowl, a spoon.</p>';
      card.innerHTML = html + '<button type="button" class="back" id="back">← Back</button>';
      document.getElementById("back").addEventListener("click", function(){
        goBack(); return;
      });
      autoNext(12000, function(){ advanceFrom(fromKey); });
      return;
    }
    card.innerHTML = html;
  }

  function advanceFrom(key){
    var i = STEPS.findIndex(s => s.key === key);
    step = i + 1;
    while (step < STEPS.length && STEPS[step].when && !STEPS[step].when(answers)) step++;
    if (step < STEPS.length) renderStep(); else if (!lead) renderBuild(); else renderResult();
    window.scrollTo({ top:0, behavior:"smooth" });
  }

  /* ---- the honest dead end ---- */
  function renderStop(kind){
    drawProg();
    hideBelow();
    say(null);
    Array.prototype.forEach.call(prog.children, el => el.className = "");

    var lead_in = kind === "allergy"
      ? 'A wheat allergy is not worth the risk. This is wheat dough. Italian flour does not change that.'
      : kind === "optout"
        ? 'Fair enough. This is wheat. Your call, and it is the right one to make yourself.'
        : 'This is wheat. Two kinds. No version of it is safe with celiac. We would rather lose the sale than make you sick.';

    card.innerHTML =
      '<div class="r-kicker" style="color:var(--tomato)">Straight answer</div>' +
      '<h1 class="qtitle">Not for you. Not yet.</h1>' +
      '<p class="qsub">' + lead_in + '</p>' +

      '<div class="fit" style="margin-top:20px"><b>No workarounds either.</b> ' +
        'Almond flour will not work here. Cauliflower will not either. ' +
        'The whole method needs gluten.</div>' +

      (kind === "allergy"
        ? '<div class="reframe" style="margin-top:12px"><b>One question first.</b> ' +
          'Were you tested? People say "allergic to wheat" for two different things. ' +
          'A real allergy. Or wheat just not agreeing with them. ' +
          'If it is the second, come back. ' +
          '<button type="button" class="linkish" id="retest">Never tested — take me back</button></div>'
        : '') +

      '<form id="gf-form" novalidate>' +
        '<label class="gate-lab" for="gf-email">Want to know if we make a gluten-free kit?</label>' +
        '<input class="gate-in" id="gf-email" name="email" type="email" autocomplete="email" ' +
          'inputmode="email" placeholder="you@example.com">' +
        '<p class="gate-err" id="gf-err" hidden>That doesn\'t look like an email address.</p>' +
        '<button type="submit" class="cta">Tell me when it happens</button>' +
      '</form>' +
      '<p class="fine">One email. Only if it happens. Nothing else.</p>' +
      '<button type="button" class="back" id="back">← Go back</button>';

    var f = document.getElementById("gf-form"),
        i = document.getElementById("gf-email"),
        e = document.getElementById("gf-err");

    f.addEventListener("submit", function(ev){
      ev.preventDefault();
      var v = i.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { e.hidden = false; i.focus(); return; }
      /* PROTOTYPE — live page posts this to a separate Klaviyo list tagged gluten_free_waitlist,
         which doubles as the demand signal for whether the product is worth making. */
      card.innerHTML =
        '<div class="r-kicker">Noted</div>' +
        '<h1 class="qtitle">We will tell you.</h1>' +
        '<p class="qsub">No newsletter. No pizza offers. ' +
          'Your name helps us decide if we build it.</p>';
      window.scrollTo({ top:0, behavior:"smooth" });
    });

    document.getElementById("back").addEventListener("click", goBack);

    var re = document.getElementById("retest");
    if (re) re.addEventListener("click", function(){
      answers.why = { k:"neither" };
      renderLearn("neither");
      window.scrollTo({ top:0, behavior:"smooth" });
    });
  }


  var ICO = {
    box:'<svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true"><path d="M4 10 L15 5 L26 10 V22 L15 27 L4 22 Z" fill="#fff" stroke="#253230" stroke-width="1.5"/><path d="M4 10 L15 15 L26 10 M15 15 V27" stroke="#253230" stroke-width="1.5" fill="none"/><path d="M20 3 q2 2 0 4 M23 4 q2 2 0 4" stroke="#d0473e" stroke-width="1.4" fill="none"/></svg>',
    jar:'<svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true"><rect x="7" y="8" width="16" height="19" rx="3" fill="#fff" stroke="#253230" stroke-width="1.5"/><rect x="9" y="4" width="12" height="4" rx="1.5" fill="#253230"/><path d="M11 17 h8 M11 21 h5" stroke="#0f855b" stroke-width="1.8" stroke-linecap="round"/></svg>',
    snow:'<svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true"><g stroke="#0f855b" stroke-width="1.8" stroke-linecap="round"><path d="M15 3 V27 M4.6 9 L25.4 21 M4.6 21 L25.4 9"/><path d="M12 5.5 L15 8 L18 5.5 M12 24.5 L15 22 L18 24.5"/></g></svg>'
  };
  /* ---- the 48-hour hold. FINAL BUILD: the deadline is set when the email comes in and saved
     on the Klaviyo profile. The quiz price must really expire then (a code that stops working,
     or a first-box bonus that ends). If nothing expires, take this block out. ---- */
  var HOLD_MS = 48 * 3600 * 1000, deadline = null;
  function getDeadline(){
    if (deadline) return deadline;
    try { var v = +localStorage.getItem("prepa_hold"); if (v > Date.now()) deadline = v; } catch(e){}
    if (!deadline) { deadline = Date.now() + HOLD_MS; try { localStorage.setItem("prepa_hold", deadline); } catch(e){} }
    return deadline;
  }
  function pad(n){ return (n < 10 ? "0" : "") + n; }
  function tick(){
    var left = Math.max(0, getDeadline() - Date.now()), t = Math.floor(left / 1000);
    var txt = pad(Math.floor(t / 3600)) + ":" + pad(Math.floor(t % 3600 / 60)) + ":" + pad(t % 60);
    Array.prototype.forEach.call(document.querySelectorAll("[data-clock]"), function(el){ el.textContent = txt; });
  }
  setInterval(tick, 1000);
  function holdUntil(){
    var d = new Date(getDeadline());
    return d.toLocaleDateString("en-US", { weekday:"long" }) + " at " +
           d.toLocaleTimeString("en-US", { hour:"numeric", minute:"2-digit" });
  }

  function profileChips(){
    var a = answers, out = [];
    if (a.people) out.push(["Table", a.people.t]);
    if (a.freq) out.push(["Pizza night", a.freq.t]);
    if (a.style) out.push(["Style", STYLE_NAME[a.style.k]]);
    if (a.oven) out.push(["Cooking on", a.oven.t]);
    if (a.exp) out.push(["Dough", a.exp.t]);
    return out.map(function(c){ return '<span class="chip"><em>' + c[0] + ':</em> ' + c[1] + '</span>'; }).join('');
  }
  function keep3(){
    return '<div class="keep3">' +
      '<div>' + ICO.box  + '<div><b>Packed fresh</b><span>Packed when you order.</span></div></div>' +
      '<div>' + ICO.jar  + '<div><b>Keeps a year</b><span>Sealed, in the pantry.</span></div></div>' +
      '<div>' + ICO.snow + '<div><b>Freezes great</b><span>Freeze what you don\'t bake.</span></div></div>' +
    '</div>';
  }
  function freezeLine(){
    var per = PER_KIT, eat = answers.people.pies;
    if (eat >= per) return '';
    return '<p class="freeze-note"><b>Small pizza night?</b> One bag makes ' + per + ' balls. ' +
      'Bake ' + eat + ' tonight. Freeze ' + (per - eat) + '. Pull one out any night.</p>';
  }

  /* ---- "your pizza night profile": where they are, where they're going, what they get ---- */
  var LEVEL = {
    never: { at:12, name:"Beginner", note:"You're starting fresh. Good. No bad habits to undo." },
    flop:  { at:34, name:"Learning", note:"You've tried. The dough fought back. That's a recipe problem, not a you problem." },
    meh:   { at:64, name:"Almost there", note:"You can make pizza. The last step is dough that tastes like a pizzeria." }
  };
  function renderProfile(){
    step = STEPS.length; drawProg(); hideBelow(); say("profile");
    var L = LEVEL[answers.exp ? answers.exp.k : "never"];
    var rate = answers.people.pies * answers.freq.per / PER_KIT;
    var pick = choose(rate);
    card.innerHTML =
      '<div class="r-kicker">Your pizza night profile</div>' +
      '<h1 class="qtitle">Here is where you are.</h1>' +
      '<div class="gauge">' +
        '<div class="g-track"><span></span><span></span><span></span><span></span></div>' +
        '<div class="g-pin" style="left:' + L.at + '%"><em>You</em></div>' +
        '<div class="g-goal" style="left:92%"><em>Your goal</em></div>' +
        '<div class="g-lab"><span>Beginner</span><span>Learning</span><span>Almost there</span><span>Pizzeria</span></div>' +
      '</div>' +
      '<div class="lvl"><b>' + L.name + '.</b> ' + L.note + '</div>' +
      '<div class="tiles">' +
        '<div><span>Pizzas a month</span><b class="num">' + Math.round(rate * PER_KIT) + '</b></div>' +
        '<div><span>Your box</span><b>' + pick.t.kits + ' kits · ' + cadLab(pick.c) + '</b></div>' +
        '<div><span>Cooking on</span><b>' + answers.oven.t + '</b></div>' +
        '<div><span>Your help</span><b>Masterclass + phone</b></div>' +
      '</div>' +
      '<p class="fine">Building your plan…</p>';
    autoNext(5500, function(){
      if (lead) renderResult(); else renderGate();
      window.scrollTo({ top:0, behavior:"smooth" });
    });
    window.scrollTo({ top:0, behavior:"smooth" });
  }
  /* ---- "building your box": the bars run, and a four-beat freeze demo plays beside them.
         No question, no interruption — it just shows them the thing most people do not know.
         FINAL BUILD: each .fz-art swaps for a real photo of that beat. ---- */
  var FZ_ART = {
    ball:'<svg viewBox="0 0 64 64" aria-hidden="true"><ellipse cx="32" cy="40" rx="20" ry="15" fill="#f0dcae" stroke="#253230" stroke-width="2"/><path d="M18 36 q7 -7 14 -3 q7 4 14 -1" fill="none" stroke="#d9c38c" stroke-width="2"/></svg>',
    tub:'<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M16 22 h32 l-4 30 a3 3 0 0 1 -3 2.6 h-18 a3 3 0 0 1 -3 -2.6 Z" fill="#eaf2f7" stroke="#253230" stroke-width="2"/><ellipse cx="32" cy="42" rx="12" ry="8" fill="#f0dcae" stroke="#253230" stroke-width="1.6"/><rect x="13" y="17" width="38" height="6" rx="3" fill="#cfe0ea" stroke="#253230" stroke-width="2"/></svg>',
    rise:'<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M16 22 h32 l-4 30 a3 3 0 0 1 -3 2.6 h-18 a3 3 0 0 1 -3 -2.6 Z" fill="#eaf2f7" stroke="#253230" stroke-width="2"/><ellipse cx="32" cy="36" rx="15" ry="12" fill="#f0dcae" stroke="#253230" stroke-width="1.6"/><rect x="13" y="17" width="38" height="6" rx="3" fill="#cfe0ea" stroke="#253230" stroke-width="2"/><path d="M32 12 v-5 M24 14 v-4 M40 14 v-4" stroke="#0f855b" stroke-width="2.2" stroke-linecap="round"/></svg>',
    cold:'<svg viewBox="0 0 64 64" aria-hidden="true"><rect x="16" y="8" width="32" height="48" rx="5" fill="#fff" stroke="#253230" stroke-width="2"/><path d="M16 26 h32" stroke="#253230" stroke-width="2"/><path d="M42 16 v6 M42 32 v8" stroke="#253230" stroke-width="2.4" stroke-linecap="round"/><g stroke="#0f855b" stroke-width="1.8" stroke-linecap="round"><path d="M28 36 v12 M23 39 l10 6 M23 45 l10 -6"/></g></svg>'
  };
  var FZ = [
    ["ball", "Make the dough", "Six balls from one kit", "You only bake what you need tonight."],
    ["tub",  "Into a container", "Any small tub with a lid", "<b>No special kit.</b> A deli tub or a soup container does it."],
    ["rise", "Let it rise", "Then straight in cold", "Up to 2 days in the fridge if you are making ahead."],
    ["cold", "Freeze the rest", "Keeps up to 6 months", "<b>Pull one out any night.</b> That is the part most people miss."]
  ];
  function renderBuild(){
    step = STEPS.length; drawProg(); hideBelow(); say(null);
    var bars = ["Sizing your box", "Matching your oven", "Setting your price"];
    card.innerHTML =
      '<div class="r-kicker">One moment</div>' +
      '<h1 class="qtitle">Building your box…</h1>' +
      '<div class="bars">' + bars.map(function(t, i){
        return '<div class="bar"><div class="bar-t"><span>' + t + '</span><em id="bp' + i + '">0%</em></div><i><b id="bb' + i + '"></b></i></div>';
      }).join('') + '</div>' +
      '<div class="fz"><div class="fz-h">While we do that — leftover dough</div>' +
        '<div class="fz-row">' +
          FZ.map(function(f, i){
            return '<div class="fz-s" id="fz' + i + '"><div class="fz-art">' + FZ_ART[f[0]] + '</div>' +
                   '<b>' + f[1] + '</b><span>' + f[2] + '</span></div>';
          }).join('') +
        '</div>' +
        '<p class="fz-cap" id="fz-cap">' + FZ[0][3] + '</p>' +
      '</div>' +
      '<div class="autorow"><div style="flex:1"></div>' +
        '<button type="button" class="skipb" id="fz-skip">Skip ahead →</button></div>';

    /* the four beats light up in turn, each with its own caption */
    document.getElementById("fz0").classList.add("on");
    [1, 2, 3].forEach(function(n){
      later(2400 * n, function(){
        var el = document.getElementById("fz" + n), cap = document.getElementById("fz-cap");
        if (!el || !cap) return;
        el.classList.add("on");
        cap.innerHTML = FZ[n][3];
      });
    });

    var i = 0, pct = 0, gone = false;
    function finish(){ if (gone) return; gone = true; clearInterval(t); renderProfile(); }
    document.getElementById("fz-skip").addEventListener("click", finish);
    var t = setInterval(function(){
      if (PAUSED) return;
      pct += 4;
      var bb = document.getElementById("bb" + i); if (!bb) { clearInterval(t); return; }
      bb.style.width = Math.min(pct,100) + "%";
      document.getElementById("bp" + i).textContent = pct >= 100 ? "✓" : pct + "%";
      if (pct >= 100) { i++; pct = 0; if (i === bars.length) { clearInterval(t); setTimeout(finish, 250); } }
    }, 136);   /* 75 ticks x 136ms = 10.2s — the last freeze beat lands at 7.2s, leaving 3s to read it */
  }

  /* ---- email gate: sits between the last question and the price ---- */
  function renderGate(){
    step = STEPS.length;
    drawProg();
    hideBelow();

    var rate = answers.people.pies * answers.freq.per / PER_KIT;
    var pick = choose(rate);
    var savePct = Math.round(100 * (1 - pick.c.p / (pick.t.kits * LIST)));

    card.innerHTML =
      '<div class="r-kicker">Your plan is ready</div>' +
      '<h1 class="qtitle">Where should we send it?</h1>' +
      '<p class="qsub">Your size is set. You save <b>' + savePct + '% (' + money(pick.t.kits * LIST - pick.c.p) + ')</b>. ' +
        'Add your email and we\'ll save your plan.</p>' +

      '<div class="gate-sum">' +
        '<div class="gate-row"><span>Your size</span><b>' + pick.t.kits +
          ' kits, every ' + cadLab(pick.c) + '</b></div>' +
        '<div class="gate-row"><span>That\'s</span><b>' +
          (pick.t.kits * PER_KIT) + ' pizzas' + '</b></div>' +
        '<div class="gate-row"><span>Your saving</span><b class="ok">' + savePct +
          '% · you save ' + money(pick.t.kits * LIST - pick.c.p) + '</b></div>' +
        '<div class="gate-row"><span>Your price</span><b class="hide">on the next screen →</b></div>' +
      '</div>' +
      '<form id="gate-form" novalidate>' +
        '<p class="secure"><b>Add your email to save your plan</b> and your mystery gift.</p>' +
        '<label class="gate-lab" for="gate-email">Email address</label>' +
        '<input class="gate-in" id="gate-email" name="email" type="email" ' +
          'autocomplete="email" inputmode="email" placeholder="you@example.com" required>' +
        '<p class="gate-err" id="gate-err" hidden>That doesn\'t look like an email address — check it and try again.</p>' +
        '<button type="submit" class="cta">Lock in my discount</button>' +
      '</form>' +
      '<p class="fine">One email. Unsubscribe any time.</p>' +
      keep3() + freezeLine() +

      '<button type="button" class="back" id="skip">Skip</button>' +
      '<button type="button" class="back" id="back" style="margin-left:14px">← Back</button>';
    say("gate");
    tick();

    var form = document.getElementById("gate-form");
    var input = document.getElementById("gate-email");
    var err = document.getElementById("gate-err");

    form.addEventListener("submit", function(e){
      e.preventDefault();
      var v = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        err.hidden = false; input.focus(); return;
      }
      err.hidden = true;
      lead = v;
      kSubscribe(v, null, { quiz_completed: true });   /* answers + recommended plan → Klaviyo, starts the welcome flow */
      renderResult();
      window.scrollTo({ top:0, behavior:"smooth" });
    });

    document.getElementById("skip").addEventListener("click", function(){
      lead = "skipped"; renderResult(); window.scrollTo({ top:0, behavior:"smooth" });
    });
    document.getElementById("back").addEventListener("click", function(){
      goBack(); return;
    });

    input.focus({ preventScroll:true });
  }

  /* ---- the plan they can adjust: box size, how often, how many boxes. Starts on our pick. ---- */
  var SEL = null;        /* {ti, ci, q} — null means "use the recommended plan" */
  var ADJ_OPEN = false;  /* the adjuster stays shut until they ask for it — the whole point of
                            the quiz is that they do not have to choose. Once opened it stays open. */
  function planFrom(ti, ci, q){
    var t = TIERS[ti], c = t.cad[ci];
    return { t:{ kits:t.kits * q, once:t.once * q, cad:t.cad, base:t }, c:{ d:c.d, m:c.m, p:c.p * q, base:c },
             r:(t.kits * q) / (c.d / 30), ti:ti, ci:ci, q:q };
  }
  function renderResult(){
    step = STEPS.length;
    drawProg();

    var rate = answers.people.pies * answers.freq.per / PER_KIT;
    var rec = choose(rate);
    var recTi = TIERS.indexOf(rec.t), recCi = rec.t.cad.indexOf(rec.c);
    var pick = SEL ? planFrom(SEL.ti, SEL.ci, SEL.q) : planFrom(recTi, recCi, 1);
    var adjusted = !!SEL && !(SEL.ti === recTi && SEL.ci === recCi && SEL.q === 1);
    var short = rate > pick.r * 1.35;
    var light = rate < 1.0;

    var seg = answers.exp ? answers.exp.k : "never";
    var HEAD = { never:"Your first pizza night, planned.", flop:"This time, it works.", meh:"Pizzeria good. At home." };
    var html =
      '<div class="r-kicker">' + (adjusted ? 'Your plan · adjusted by you' : 'Your plan') + '</div>' +
      '<h1 class="qtitle">' + (light ? "Two people is plenty." : HEAD[seg]) + '</h1>' +
      '<p class="qsub">Each kit makes <b>' + PER_KIT + ' pizzas</b> at 12 inches.' +
        '. Your box makes <b>' + (pick.t.kits * PER_KIT) + ' pizzas</b>. That is about <b>' +
        Math.floor(pick.t.kits * PER_KIT / answers.people.pies) + ' pizza nights</b> for your table before your next box.</p>';

    html += planCard(pick, rate);

    /* adjust it: easy by default, changeable if they want */
    var ti = pick.ti, ci = pick.ci, q = pick.q;
    html += '<details class="adj"' + (ADJ_OPEN || adjusted ? ' open' : '') + ' id="adj">' +
      '<summary>Want a different size or schedule? <em>Optional</em></summary>' +
      '<div class="adj-body">' +
      '<div class="adj-row"><span class="adj-l">Box size</span><div class="seg">' +
        TIERS.map(function(t, i){ return '<button type="button" class="sg' + (i === ti ? ' on' : '') + '" data-ti="' + i + '">' +
          t.kits + ' kits · ' + money(t.cad[Math.min(ci, t.cad.length - 1)].p) +
          (i === recTi ? '<em>Our pick</em>' : '') + '</button>'; }).join('') + '</div></div>' +
      '<div class="adj-row"><span class="adj-l">Ships every</span><div class="seg">' +
        TIERS[ti].cad.map(function(c, i){ return '<button type="button" class="sg' + (i === ci ? ' on' : '') + '" data-ci="' + i + '">' +
          cadLab(c, true) + '</button>'; }).join('') + '</div></div>' +
      '<div class="adj-row"><span class="adj-l">Boxes</span><div class="stepper">' +
        '<button type="button" id="q-minus" aria-label="One less box"' + (q <= 1 ? ' disabled' : '') + '>−</button>' +
        '<b class="num">' + q + '</b>' +
        '<button type="button" id="q-plus" aria-label="One more box"' + (q >= 4 ? ' disabled' : '') + '>+</button>' +
        '<span class="adj-note">' + (pick.t.kits * PER_KIT) + ' pizzas per delivery</span></div></div>' +
      '<p class="adj-note" style="margin:8px 0 0">How often you get it does not change the price. Pick what matches your pizza nights.</p>' +
      (adjusted ? '<button type="button" class="adj-reset" id="adj-reset">Go back to our pick</button>' : '') +
      '</div></details>';

    html += '<button type="button" class="cta" id="buy">Start my plan — ' + money(pick.c.p) + '</button>' +
            '<button type="button" class="once" id="buy-once">' +
              '<b>Or buy once for ' + money(pick.t.once) + '</b>' +
              '<span>Saves ' + Math.round(100 * (1 - pick.t.once / (pick.t.kits * LIST))) +
              '% instead of ' + Math.round(100 * (1 - pick.c.p / (pick.t.kits * LIST))) + '%. No plan, no masterclass updates.</span>' +
            '</button>' +
            '<p class="ck-note" id="ck-note" hidden></p>' +
            '<p class="fine">Free shipping. Cancel after box two.' +
              (lead && lead !== "skipped" ? ' Plan sent to ' + lead + '.' : '') + '</p>' +
            '<p class="jump">Questions first? <a href="#faq">See the answers below ↓</a></p>';


    /* ---- what happens next, written for their level ---- */
    var STEP2 = { never:["Watch the masterclass", "Video and written steps."],
                  flop: ["Watch the masterclass", "Then call us before your first bake."],
                  meh:  ["Jump to the part you need", "Shaping, stretching, baking."] };
    html += '<div class="next"><div class="next-h">What happens next</div><ol>' +
      '<li><b>We pack your box fresh</b><span>Free shipping.</span></li>' +
      '<li><b>' + STEP2[seg][0] + '</b><span>' + STEP2[seg][1] + '</span></li>' +
      '<li><b>Your first pizza night</b><span>15 minutes of work.</span></li>' +
      '<li><b>Stuck? Call us</b><span>(800) 913-8851.</span></li>' +
    '</ol></div>';
    if (answers.oven && answers.oven.k === "oven") {
      html += '<div class="fit"><b>Pizza oven tip.</b> Don\'t par-bake. Launch the dough raw. The masterclass shows you how.</div>';
    }
    /* ---- your dough plan: how many nights, what to freeze, how far ahead to start ---- */
    var pies = answers.people.pies, per = PER_KIT, kitsN = pick.t.kits;
    var nights = Math.floor(kitsN * per / pies);
    var party = answers.people.k === "6" || answers.freq.k === "d";
    var planned = Math.round(answers.freq.per * pick.c.d / 30);
    var dp = '<div class="dplan"><div class="dplan-h">Your dough plan</div><ul>';
    dp += '<li><b>' + kitsN + ' kits × ' + per + ' = ' + (kitsN * per) + ' pizzas.</b> Your table eats about ' + pies +
          ' a night. That is ' + nights + ' pizza nights. You plan about ' + planned + ' before your next box in ' + cadLab(pick.c, true) + '.' +
          (nights < planned ? ' That is more than one box covers. Add a box above, or call us and we will build you a bigger one.' : '') + '</li>';
    if (per > pies) {
      dp += '<li><b>Freeze what you don\'t bake.</b> One kit makes ' + per + ' dough balls. Bake ' + pies +
            ' tonight. Freeze the other ' + (per - pies) + '. Frozen dough keeps up to 6 months.</li>';
    }
    if (party) {
      dp += '<li><b>Big night? Make it ahead.</b> Hold the risen dough in the fridge up to 2 days (72 hours max). Party day it is ready.</li>';
    }
    dp += '<li><b>Plan ahead.</b> Not an hour-before-dinner dough. 15 minutes of work, then it rests. Start earlier in the day, or freeze it and be ready any night.</li>';
    dp += '</ul></div>';
    html += dp;

    /* ---- what a kit actually is ---- */
    var perKit = PER_KIT;
    var totalPz = pick.t.kits * perKit;

    html += '<div class="kit">' +
      '<div class="kit-h">What you get</div>' +
      '<div class="kit-body">' +

        '<div class="kit-math">' +
          '<div><b class="num">1 kit</b><span>= ' + perKit + ' pizzas at 12\"</span></div>' +
          '<div class="kit-x" aria-hidden="true">×</div>' +
          '<div><b class="num">' + pick.t.kits + ' kits</b><span>in every box</span></div>' +
          '<div class="kit-x" aria-hidden="true">=</div>' +
          '<div><b class="num tot">' + totalPz + ' pizzas</b><span>per delivery</span></div>' +
        '</div>' +

        keep3() + freezeLine() +

      '</div></div>';

    html += '<ul class="facts">' +
      '<li><span class="ck">✓</span><div><b>Free shipping.</b> <span>Every size.</span></div></li>' +
      '<li><span class="ck">✓</span><div><b>Yours after box two.</b> <span>Skip it, slow it down, or stop.</span></div></li>' +
      '<li><span class="ck">✓</span><div><b>Help if you get stuck.</b> <span>Video, written steps, and a real person on the phone.</span></div></li>' +
      '</ul>';

    /* ---- macros, sized to their pizza. Base = one 12" dough ball (6 per kit):
       292 cal · 22g protein · 0g added sugar (printed label: 25 x 30g servings, 70 cal / 5.3g protein each, / 6 balls). 10" and 14" are the
       same bag split 8 or 4 ways, so we scale by 6 / balls-per-kit. [label-verified 2026-10-06] ---- */
    var k6 = 1;
    var cal = Math.round(292 * k6), pro = Math.round(22 * k6);
    var slices = 8;
    html += '<div class="mac">' +
      '<div class="mac-h"><b>Your crust, by the numbers</b><span>One 12-inch crust · dough only</span></div>' +
      '<div class="mac-g">' +
        '<div><strong class="num">' + cal + '</strong><span>calories</span></div>' +
        '<div><strong class="num">' + pro + 'g</strong><span>protein</span></div>' +
        '<div><strong class="num">0g</strong><span>added sugar</span></div>' +
      '</div>' +
      '<div class="mac-f">Cut in ' + slices + ': about <b>' + Math.round(cal / slices) + ' calories</b> and <b>' +
        round1(pro / slices) + 'g protein</b> a slice. Toppings are up to you. Honey packet not counted.</div>' +
    '</div>';

    if (answers.oven && answers.oven.fit) {
      html += '<div class="fit"><b>It works where you cook.</b> ' + answers.oven.fit + '</div>';
    }

    /* ---- straight answers on what's in it ---- */
    var diet = answers.diet || [];
    if (diet.length) {
      var ANS = INFO;

      html += '<div class="diet"><div class="diet-h">Straight answers</div>';
      diet.forEach(function(k){
        var a = ANS[k]; if (!a) return;
        var glyph = a.m === "yes" ? "✓" : (a.m === "no" ? "✕" : "i");
        html += '<div class="diet-i"><span class="mark ' + a.m + '" aria-hidden="true">' + glyph + '</span>' +
                '<div><b>' + a.t + '</b>' + (a.s ? '<span>' + a.s + '</span>' : '') +
                (k === "clean" || k === "allergy" ? SIX : '') +
                '</div></div>';
      });
      html += '</div>';
    }

    if (light) {
      html += '<div class="reframe"><b>Two people is plenty.</b> ' +
        'This box lasts about ' + round1(pick.t.kits / rate) + ' months.</div>';
    }

    if (answers.priority && answers.priority.k === "price") {
      html += '<div class="reframe"><b>About the price.</b> Your box works out to <b>' +
        money(pick.c.p / (pick.t.kits * PER_KIT)) + ' a pizza</b>. Less than one delivery pizza.</div>';
    }

    if (short) {
      html += '<div class="reframe"><b>You eat more than this page covers.</b> ' +
        'You would run this plan down early. Ask us about bigger boxes first.</div>';
    }

    /* Guard: a light household staring at a big number is the one case where the
       best-fitting plan is the wrong opener. Surface a smaller start, visibly. */
    if (rate < 1.6 && pick.c.p > 150) {
      var small = null;
      TIERS.forEach(function(t){
        t.cad.forEach(function(c){
          if (c.p > 140) return;
          var r = t.kits / (c.d / 30);
          var d = Math.abs(r - rate);
          if (!small || d < small.d - 1e-9) small = { t:t, c:c, r:r, d:d };
        });
      });
      if (small) {
        html += '<div class="reframe" style="margin-top:14px"><b>Want to start smaller?</b> ' +
          small.t.kits + ' kits every ' + cadLab(small.c) + ' is ' +
          money(small.c.p) + '. About ' + round1(small.t.kits / rate) +
          ' months at your pace. You can size up any time.</div>';
      }
    }

    html += '<button type="button" class="back" id="back">← Change my answers</button>';

    card.innerHTML = html;
    function reSel(n){ SEL = n; var y = window.scrollY; renderResult(); window.scrollTo(0, y); }
    var adjEl = document.getElementById("adj");
    if (adjEl) adjEl.addEventListener("toggle", function(){ ADJ_OPEN = adjEl.open; });
    Array.prototype.forEach.call(card.querySelectorAll(".adj [data-ti]"), function(b){
      b.addEventListener("click", function(){ var nt = +b.dataset.ti;
        reSel({ ti:nt, ci:Math.min(pick.ci, TIERS[nt].cad.length - 1), q:pick.q }); });
    });
    Array.prototype.forEach.call(card.querySelectorAll(".adj [data-ci]"), function(b){
      b.addEventListener("click", function(){ reSel({ ti:pick.ti, ci:+b.dataset.ci, q:pick.q }); });
    });
    document.getElementById("q-minus").addEventListener("click", function(){ reSel({ ti:pick.ti, ci:pick.ci, q:Math.max(1, pick.q - 1) }); });
    document.getElementById("q-plus").addEventListener("click", function(){ reSel({ ti:pick.ti, ci:pick.ci, q:Math.min(4, pick.q + 1) }); });
    var rs = document.getElementById("adj-reset"); if (rs) rs.addEventListener("click", function(){ reSel(null); });
    SAY.result = { never:"pam", flop:"michele", meh:"matthew" }[seg];
    say("result");
    tick();
    renderBelow(pick);

    function checkout(once){
      if (lead && lead !== "skipped") kSubscribe(lead, pick, { quiz_checkout_started: true });  /* final box, if they adjusted it */
      if (isLive()) {
        var items = [{ id: VARIANT[pick.ti], quantity: pick.q }];
        if (!once) { items[0].selling_plan = PLAN[pick.ti][pick.ci]; items.push({ id: GIFT_VARIANT, quantity: 1 }); }
        var attrs = { quiz_box: String(pick.t.base.kits), quiz_cadence: (pick.c.d / 7) + " weeks",
                      quiz_people: ansK("people"), crust_style: ansK("style"), quiz_oven: ansK("oven") };
        fetch("/cart/clear.js", { method: "POST" })
          .then(function(){ return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) }); })
          .then(function(r){ if (!r.ok) throw new Error("add " + r.status); return fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: attrs }) }); })
          .then(function(){ location.href = "/checkout"; })
          .catch(function(){ location.href = PRODUCT_URL[pick.ti] + (once ? "" : "?selling_plan=" + PLAN[pick.ti][pick.ci]); });
        return;
      }
      var n = document.getElementById("ck-note");
      n.hidden = false;
      n.textContent = "Prototype: this goes straight to checkout with " + pick.t.kits + " kits" +
        (once ? ", one time." : ", every " + cadLab(pick.c) + ".");
      document.getElementById("buy").scrollIntoView({ behavior:"smooth", block:"center" });
    }
    document.getElementById("buy").addEventListener("click", function(){ checkout(false); });
    document.getElementById("buy-once").addEventListener("click", function(){ checkout(true); });
    Array.prototype.forEach.call(document.querySelectorAll("[data-buy]"), function(b){
      b.addEventListener("click", function(){ checkout(false); });
    });

    /* sticky bar: shows only once the main button has scrolled out of view */
    document.getElementById("sticky-t").innerHTML = '<b>' + pick.t.kits + ' kits, every ' + cadLab(pick.c) + '</b>' +
      money(pick.c.p) + ' · you save ' + money(pick.t.kits * LIST - pick.c.p) + ' today';
    document.getElementById("sticky-go").onclick = function(){ checkout(false); };
    document.body.classList.add("has-sticky");
    if ("IntersectionObserver" in window) {
      if (window.__stickyObs) window.__stickyObs.disconnect();
      window.__stickyObs = new IntersectionObserver(function(es){
        es.forEach(function(e){ sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0; });
      });
      window.__stickyObs.observe(document.getElementById("buy"));
    }

    document.getElementById("back").addEventListener("click", function(){
      step = 0; renderStep(); window.scrollTo({ top:0, behavior:"smooth" });
    });
  }

  /* ---- the rest of the PDP, below the fold on the plan page ---- */
  function note(k){
    var r = R[k];
    return '<article class="note">' + stars() + '<p>“' + r.q + '”</p>' +
      '<footer><b>' + r.n + '</b><span class="vf">' + r.src + '</span></footer></article>';
  }
  function wallOrder(){
    var seg = answers.exp ? answers.exp.k : "never";
    var first = { never:["pam","eric","cheryl"], flop:["michele","ian","wb"], meh:["matthew","danny","kevin"] }[seg];
    var rest = ["michele","matthew","danny","eric","cheryl","gordon","ian","mike"].filter(function(k){ return first.indexOf(k) < 0; });
    return first.concat(rest).slice(0, 8);
  }
  function renderBelow(pick){
    var buy = 'Start my plan — ' + money(pick.c.p);
    var F = [
      ["Do I need a pizza oven?", "No. Your home oven works. A sheet pan is enough. Got a pizza oven or a grill? Even better."],
      ["How many pizzas is one kit?", "Six at 10–12 inches hand tossed. Thin or smaller gives you more, a deep pan gives you fewer."],
      ["Do I have to make them all at once?", "No. A sealed kit keeps a year. Make the dough, then freeze what you won't bake."],
      ["How much work is it?", "About 15 minutes of hands-on time. The rest is waiting."],
      ["What is in it?", "Six things. Milled 00 from Italian grown wheat. Olive oil. Sea salt. Yeast. Diastatic malt. Honey in its own packet. Semolina comes too, for dusting."],
      ["Is it gluten-free?", "No. It is wheat. If you have celiac or a wheat allergy, this is not for you."],
      ["Can I cancel?", "Yes. Keep your first two boxes. After that, skip, slow down, or stop."]
    ];
    below.innerHTML =
      /* reviews */
      '<section class="sec" aria-labelledby="rv-h">' +
        '<div class="eyebrow">Reviews</div>' +
        '<h2 id="rv-h">Home cooks love it.</h2>' +
        '<div class="rvhead"><span class="big num">4.99</span><div>' + stars() +
          '<small>6,377 reviews · 300,000+ pizzas made</small></div></div>' +
        '<div class="wall">' + wallOrder().map(note).join('') + '</div>' +
      '</section>' +

      /* how to make it */
      '<section class="sec" aria-labelledby="how-h">' +
        '<div class="eyebrow">How it works</div>' +
        '<h2 id="how-h">15 minutes of work. The clock does the rest.</h2>' +
        '<ol class="steps">' +
          '<li><span class="n">1</span><div><b>Mix</b><span>Bag, water, bowl, spoon. Stir. Walk away.</span></div></li>' +
          '<li><span class="n">2</span><div><b>Mix again</b><span>A quick second mix. Walk away.</span></div></li>' +
          '<li><span class="n">3</span><div><b>Fold</b><span>Fold the dough. Let it rest.</span></div></li>' +
          '<li><span class="n">4</span><div><b>Shape and bake</b><span>Stretch it. Top it. Bake it.</span></div></li>' +
        '</ol>' +
        '<p class="need"><b>You need:</b> water, a bowl, a spoon. Your sauce and toppings.</p>' +
      '</section>' +

      /* masterclass */
      '<section class="sec mc" aria-labelledby="mc-h">' +
        '<div><div class="eyebrow">Included free</div>' +
        '<h2 id="mc-h">The masterclass comes with it.</h2></div>' +
        '<ul>' +
          '<li>Full video lessons. Step by step.</li>' +
          '<li>Written steps too. No phone in the flour.</li>' +
          '<li>Home oven, pizza oven, grill. All covered.</li>' +
          '<li>It turns any home cook into a home pizza master.</li>' +
        '</ul>' +
        '<p class="phone">Stuck? Call <b>(800) 913-8851</b>. A real person picks up.</p>' +
      '</section>' +

      /* story */
      '<section class="sec" aria-labelledby="st-h">' +
        '<div class="eyebrow">Why it tastes better</div>' +
        '<h2 id="st-h">World championship recipe.</h2>' +
        '<div class="story">' +
          '<svg class="badge" viewBox="0 0 88 88" aria-hidden="true"><circle cx="44" cy="44" r="42" fill="#253230"/><circle cx="44" cy="44" r="35" fill="none" stroke="#f3fc81" stroke-width="1.5" stroke-dasharray="3 4"/><path d="M28 36 h32 l-4 20 h-24 Z" fill="#f3fc81"/><path d="M28 36 q-8 0 -6 8 q2 6 8 5 M60 36 q8 0 6 8 q-2 6 -8 5" stroke="#f3fc81" stroke-width="2.4" fill="none"/><rect x="38" y="56" width="12" height="6" fill="#f3fc81"/><rect x="32" y="62" width="24" height="4" rx="1.5" fill="#f3fc81"/></svg>' +
          '<div>' +
            '<p>I tried every premade dough, kit and recipe out there. Almost none gave me the pizza I wanted.</p>' +
            '<p>Pizzerias do it differently. They start with the best ingredients they can find. Then they build a recipe to match. <b>So that is what we put in the bag.</b></p>' +
            '<p>I compete at the world pizza championships. My first time, I placed in the <b>top 25%</b>. This is that dough.</p>' +
            '<p class="sig">— Michael, co-founder</p>' +
          '</div>' +
        '</div>' +
      '</section>' +

      /* 7 things people ask */
      '<section class="sec" id="faq" aria-labelledby="faq-h">' +
        '<div class="eyebrow">Before you buy</div>' +
        '<h2 id="faq-h">7 things people ask.</h2>' +
        '<ul class="faq">' + F.map(function(f){ return '<li><b>' + f[0] + '</b><span>' + f[1] + '</span></li>'; }).join('') + '</ul>' +
      '</section>' +

      /* guarantee + last button */
      '<section class="sec">' +
        '<div class="guar"><svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true"><path d="M20 3 L34 8 V19 C34 28 27 34 20 37 C13 34 6 28 6 19 V8 Z" fill="#0f855b"/><path d="M13 20 l5 5 l9 -10" stroke="#fff" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<div><b>100% satisfaction guaranteed.</b><span>Not happy? We make it right.</span></div></div>' +
        '<button type="button" class="cta" data-buy>' + buy + '</button>' +
        '<p class="fine">' + pick.t.kits + ' kits every ' + cadLab(pick.c) + '. Free shipping. Cancel after box two.</p>' +
      '</section>';
    below.hidden = false;
  }


  /* ---- exit-intent email catch (v57). Shows once per visit, only before they have given
     an email at the gate. Desktop: mouse leaves through the top. Mobile: back button.
     LIVE PAGE: on submit, Klaviyo identify with email + every answer so far, plus
     quiz_exit_capture = true and quiz_last_step, so the follow-up email can finish the quiz for them. ---- */
  /* LIVE PAGE: use https://cdn.shopify.com/s/files/1/0859/6373/5333/files/jolene-peel-crop.jpg?v=1791320074&width=800 instead of this data URI */
  var XI_IMG = "https://cdn.shopify.com/s/files/1/0859/6373/5333/files/jolene-peel-crop.jpg?v=1791320074&width=800";
  var XI_SHOWN = false;
  function xiEligible(){
    return !XI_SHOWN && lead === null && !document.getElementById("gate-form") &&
           !document.querySelector(".plan") && step > 0;
  }
  function xiOpen(){
    if (!xiEligible()) return false;
    XI_SHOWN = true;
    var bg = document.createElement("div");
    bg.className = "xi-bg"; bg.setAttribute("role","dialog"); bg.setAttribute("aria-modal","true");
    bg.setAttribute("aria-labelledby","xi-h");
    bg.innerHTML =
      '<div class="xi">' +
        '<button type="button" class="xi-x" aria-label="Close">×</button>' +
        '<div class="xi-top">' +
          '<img class="xi-img" src="' + XI_IMG + '" alt="Jolene from Prepa Pizza, laughing and swinging a pizza peel">' +
          '<span class="xi-tag">🎁 Free mystery gift</span>' +
        '</div>' +
        '<div class="xi-body">' +
          '<h2 id="xi-h">Hold it <em>right there!</em></h2>' +
          '<p class="xi-lead">Jolene\'s not letting you leave without your free gift.</p>' +
          '<ul class="xi-perks">' +
            '<li>Your pizza plan, saved to your inbox</li>' +
            '<li>A mystery gift in your first subscription box</li>' +
            '<li>Free shipping on every order</li>' +
          '</ul>' +
          '<form id="xi-form" novalidate>' +
            '<label class="gate-lab" for="xi-email">Email address</label>' +
            '<input class="gate-in" id="xi-email" type="email" autocomplete="email" inputmode="email" placeholder="Your email address" required>' +
            '<p class="gate-err" id="xi-err" hidden>That doesn\'t look like an email address. Check it and try again.</p>' +
            '<button type="submit" class="cta">Save my free gift →</button>' +
          '</form>' +
          '<p class="xi-trust">Join 50,000+ home cooks · No spam, unsubscribe anytime</p>' +
          '<button type="button" class="xi-no">I\'ll finish my plan now</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(bg);
    function close(){ if (bg.parentNode) bg.parentNode.removeChild(bg); }
    bg.querySelector(".xi-x").addEventListener("click", close);
    bg.querySelector(".xi-no").addEventListener("click", close);
    bg.addEventListener("click", function(e){ if (e.target === bg) close(); });
    document.addEventListener("keydown", function esc(e){ if (e.key === "Escape") { close(); document.removeEventListener("keydown", esc); } });
    bg.querySelector("#xi-form").addEventListener("submit", function(e){
      e.preventDefault();
      var inp = bg.querySelector("#xi-email"), err = bg.querySelector("#xi-err"), v = inp.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { err.hidden = false; inp.focus(); return; }
      lead = v;
      kSubscribe(v, null, { quiz_completed: false, quiz_exit_capture: true, quiz_last_step: step });
      bg.querySelector(".xi").innerHTML =
        '<div class="xi-done"><h2 id="xi-h">Saved! <em>🎁</em></h2><p>Your plan is on its way to your inbox, and your mystery gift is saved for your first subscription box. Want to finish your plan now? It takes a minute.</p>' +
        '<button type="button" class="cta" id="xi-done">Finish my plan</button></div>';
      bg.querySelector("#xi-done").addEventListener("click", close);
    });
    var f = bg.querySelector("#xi-email"); if (f) f.focus({ preventScroll:true });
    return true;
  }
  document.addEventListener("mouseout", function(e){
    if (!e.relatedTarget && e.clientY <= 0) xiOpen();
  });
  try {
    history.pushState({ xi:1 }, "");
    window.addEventListener("popstate", function(){
      if (xiOpen()) { try { history.pushState({ xi:1 }, ""); } catch(_){} }
    });
  } catch(_){}

  renderStep();
})();
